/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		4: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + ".chunk." + {"0":"6dbbb","1":"23567","2":"deae8"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://staticpg.paytmpayments.com/link/418/form/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "G1eP");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/VeU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Bm0":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function TempCtor() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (load) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);
		var done = function done(child) {
			_this.setState({ child: child && child.default || child });
		};
		var r = load(done);
		if (r && r.then) r.then(done);
	}
	Async.prototype = new _preact.Component();
	Async.prototype.constructor = Async;
	Async.prototype.render = function (props, state) {
		return (0, _preact.h)(state.child, props);
	};
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "7YXT":
/***/ (function(module, exports) {

var flexibleAmount = {
  linkId: 153298073,
  merchantId: "qNLEbz38834473442956",
  merchantName: "Test1",
  linkDescription: "ewfsdgndsafb",
  linkName: "48056",
  expiryDate: "25 Aug, 2021",
  status: "PENDING",
  longUrl: "https://paytm.business/link/paymentForm/48056/LL_153298073",
  shortUrl: "https://paytm.me/YN-A5AP",
  smartPhone: false,
  templateInfo: "Grocery Bill",
  isPartialPayment: false,
  fields: [{
    name: "Test",
    type: "Text",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: false,
    size: 100,
    constraints: { maxLength: "30", minLength: "3", isMandatoryValidation: false, validationType: "textValidation" },
    placeholder: "Test",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Email ID",
    type: "Text",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: { maxLength: "200", minLength: "3", isMandatoryValidation: true, validationType: "textValidation" },
    placeholder: "Email ID*",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "DOB",
    type: "Date",
    displayText: "",
    helpText: "afgasdadhasghdasgjdhaghdasghj",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: {
      maxValue: "31/07/2020",
      minValue: "01/08/2018",
      isMandatoryValidation: true,
      validationType: "dateValidation"
    },
    subText: "afgasdadhasghdasgjdhaghdasghj",
    placeholder: "DOB*",
    isError: false,
    errorName: "",
    inputValue: ""
  }, {
    name: "Amount",
    type: "Amount",
    displayText: "Enter Amount",
    helpText: "",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: {
      minValue: "1",
      maxValue: "10000000",
      isMandatoryValidation: true,
      validationType: "numberValidation"
    },
    placeholder: "Enter Amount*",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }],
  partialPayment: false,
  partialAmountData: {
    isPartialPayment: false,
    paidAmount: "",
    blockAmount: "",
    payableAmount: "",
    totalAmount: "",
    partialLinkPayments: []
  }
};
var fixedAmount = {
  linkId: 126619845,
  merchantId: "qNLEbz38834473442956",
  merchantName: "Test1",
  linkDescription: "Testing",
  linkName: "46406",
  expiryDate: "06 Jul, 2021",
  status: "PENDING",
  longUrl: "https://paytm.business/link/paymentForm/46406/LL_126619845",
  shortUrl: "https://paytm.me/OQa-WWs",
  smartPhone: false,
  templateInfo: "Link for Terms and Conditions: https://paytm.business/theia/linkPaymentRedirect",
  isPartialPayment: false,
  fields: [{
    name: "First Name",
    type: "Text",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: { maxLength: "30", minLength: "3", isMandatoryValidation: true, validationType: "textValidation" },
    parentField: "Full Name",
    placeholder: "First Name*",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Last Name",
    type: "Text",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: { maxLength: "30", minLength: "3", isMandatoryValidation: true, validationType: "textValidation" },
    parentField: "Full Name",
    placeholder: "Last Name*",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Mobile Number",
    type: "Numeric",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: {
      maxLength: "10",
      minLength: "10",
      isMandatoryValidation: true,
      validationType: "numberValidation"
    },
    placeholder: "Mobile Number*",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Product fee",
    type: "Amount",
    displayText: "",
    helpText: "Select if you agree to T&C",
    orientation: "H",
    mandatory: false,
    size: 100,
    constraints: {
      value: "1000",
      minValue: "0",
      maxValue: "10000000",
      isMandatoryValidation: false,
      validationType: "numberValidation"
    },
    subText: "Select if you agree to T&C",
    placeholder: "Product fee",
    isError: false,
    errorName: "",
    inputValue: "1000"
  }],
  partialPayment: false,
  partialAmountData: {
    isPartialPayment: false,
    paidAmount: "",
    blockAmount: "",
    payableAmount: "",
    totalAmount: "",
    partialLinkPayments: []
  }
};
var allAmountFields = {
  linkId: 102275071,
  merchantId: "qNLEbz38834473442956",
  merchantName: "Test1",
  linkDescription: "amtfield",
  linkName: "78666",
  expiryDate: "02 Jun, 2021",
  status: "PENDING",
  longUrl: "https://paytm.business/link/paymentForm/78666/LL_102275071",
  shortUrl: "https://paytm.me/6IW-irT",
  smartPhone: false,
  templateInfo: "TestP",
  isPartialPayment: false,
  fields: [{
    name: "Fixed amiunt",
    type: "Amount",
    displayText: "",
    helpText: "This is Fixed amount field",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: {
      value: "50",
      minValue: "0",
      maxValue: "10000000",
      isMandatoryValidation: true,
      validationType: "numberValidation"
    },
    subText: "This is Fixed amount field",
    placeholder: "Fixed amiunt*",
    isError: false,
    errorName: "",
    inputValue: "50"
  }, {
    name: "flexi Field",
    type: "Amount",
    displayText: "",
    helpText: "Amount flexible field",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: { minValue: "10", maxValue: "990", isMandatoryValidation: true, validationType: "numberValidation" },
    subText: "Amount flexible field",
    placeholder: "flexi Field*",
    isError: false,
    errorName: "",
    inputValue: ""
  }, {
    name: "Quantity",
    type: "QuantityAmount",
    displayText: "",
    helpText: "Field with quantity",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: {
      value: "50",
      minQuantity: "1",
      maxQuantity: "10",
      minValue: "1",
      maxValue: "10",
      isMandatoryValidation: true,
      validationType: "numberValidation"
    },
    subText: "Field with quantity",
    placeholder: "Quantity*",
    isError: false,
    errorName: "",
    inputValue: ""
  }, {
    name: "test",
    type: "Amount",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: {
      value: "1",
      minValue: "0",
      maxValue: "10000000",
      isMandatoryValidation: true,
      validationType: "numberValidation"
    },
    placeholder: "test*",
    isError: false,
    errorName: "",
    inputValue: "1",
    subText: ""
  }],
  partialPayment: false,
  partialAmountData: {
    isPartialPayment: false,
    paidAmount: "",
    blockAmount: "",
    payableAmount: "",
    totalAmount: "",
    partialLinkPayments: []
  }
};
var dropDownAmountField2 = {
  linkId: 153298073,
  merchantId: "qNLEbz38834473442956",
  merchantName: "Test1",
  linkDescription: "ewfsdgndsafb",
  linkName: "48056",
  expiryDate: "25 Aug, 2021",
  status: "PENDING",
  longUrl: "https://paytm.business/link/paymentForm/48056/LL_153298073",
  shortUrl: "https://paytm.me/YN-A5AP",
  smartPhone: false,
  templateInfo: "Grocery Bill",
  isPartialPayment: false,
  fields: [{
    name: "Test",
    type: "Text",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: false,
    size: 100,
    constraints: { maxLength: "30", minLength: "3", isMandatoryValidation: false, validationType: "textValidation" },
    placeholder: "Test",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Email ID",
    type: "Text",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: false,
    size: 100,
    constraints: { maxLength: "200", minLength: "3", isMandatoryValidation: true, validationType: "textValidation" },
    placeholder: "Email ID*",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Gender",
    type: "Dropdown",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: false,
    size: 100,
    constraints: { allowedValues: ["Male", "Female", "Others"] }
  }, {
    name: "DOB",
    type: "Date",
    displayText: "",
    helpText: "afgasdadhasghdasgjdhaghdasghj",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: {
      maxValue: "31/07/2020",
      minValue: "01/08/2018",
      isMandatoryValidation: true,
      validationType: "dateValidation"
    },
    subText: "afgasdadhasghdasgjdhaghdasghj",
    placeholder: "DOB*",
    isError: false,
    errorName: "",
    inputValue: ""
  }, {
    name: "Amount",
    type: "Amount",
    displayText: "Enter Amount",
    helpText: "",
    orientation: "H",
    mandatory: true,
    size: 100,
    constraints: {
      minValue: "1",
      maxValue: "10000000",
      isMandatoryValidation: true,
      validationType: "numberValidation"
    },
    placeholder: "Enter Amount*",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Uditanshu",
    type: "DropdownAmount",
    displayText: "Payable Plans",
    helpText: "",
    mandatory: false,
    constraints: {
      allowedValues: [{
        name: "udit1",
        value: "283"
      }, {
        name: "udit2",
        value: "8834"
      }, {
        name: "udit4",
        value: "908"
      }, {
        name: "udiy5",
        value: "784"
      }]
    },
    orientation: "H",
    size: "100"
  }],
  partialPayment: false,
  partialAmountData: {
    isPartialPayment: false,
    paidAmount: "",
    blockAmount: "",
    payableAmount: "",
    totalAmount: "",
    partialLinkPayments: []
  }
};

var dropDownAmountField = {
  resultInfo: null,
  linkId: 45814,
  merchantId: "qa12FU97229952596781",
  merchantName: "Nitesh",
  imageName: null,
  imageData: null,
  linkDescription: "party",
  linkName: "abhi",
  amount: "99.00",
  amountMantissa: "99",
  amountExponent: "00",
  expiryDate: "15 Nov, 2024",
  status: "PENDING",
  longUrl: "https://pgp-qa5.paytm.in/link/paymentForm/abhi/LL_45814",
  shortUrl: "https://paytm.me/k-h5Jnw",
  smartPhone: false,
  customerName: "Abhi script",
  customerPhoneNo: "9957216576",
  customerEmail: "hello.family@paytm.com",
  templateInfo: "Detail",
  paidAmount: null,
  blockAmount: null,
  isPartialPayment: false,
  payableAmount: null,
  fields: [{
    name: "Name",
    type: "Text",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: false,
    size: 100,
    constraints: {
      maxLength: "200",
      minLength: "3",
      isMandatoryValidation: false,
      validationType: "textValidation"
    },
    placeholder: "Name",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Number",
    type: "Numeric",
    displayText: "",
    helpText: "",
    orientation: "V",
    mandatory: false,
    size: 100,
    constraints: {
      maxLength: "3",
      minLength: "1",
      maxValue: "150",
      minValue: "0",
      isMandatoryValidation: false,
      validationType: "numberValidation"
    },
    placeholder: "Number",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Gender",
    type: "Dropdown",
    displayText: "",
    helpText: "This is help text",
    orientation: "V",
    mandatory: false,
    size: 100,
    constraints: {
      allowedValues: ["Male", "Female"],
      isMandatoryValidation: false,
      validationType: "listValidation"
    },
    subText: "This is help text",
    placeholder: "Gender",
    isError: false,
    errorName: "",
    inputValue: ""
  }, {
    name: "Payment Plans",
    type: "DropdownAmount",
    displayText: "",
    helpText: "",
    orientation: "H",
    mandatory: false,
    size: 100,
    constraints: {
      allowedValues: [{
        value: "150",
        name: "quaterly plan"
      }, {
        value: "400",
        name: "half yearly plan"
      }, {
        value: "600",
        name: "Annual plan"
      }],
      isMandatoryValidation: false,
      validationType: "listValidation"
    },
    placeholder: "Payment Plans",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Amount1",
    type: "Amount",
    displayText: "",
    helpText: "",
    orientation: "V",
    mandatory: true,
    size: 100,
    constraints: {
      maxValue: "100",
      minValue: "1",
      isMandatoryValidation: true,
      validationType: "numberValidation"
    },
    placeholder: "Amount1*",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }, {
    name: "Amount2",
    type: "Amount",
    displayText: "",
    helpText: "",
    orientation: "V",
    mandatory: false,
    size: 100,
    constraints: {
      maxValue: "100",
      minValue: "0",
      value: "5",
      isMandatoryValidation: false,
      validationType: "numberValidation"
    },
    placeholder: "Amount2",
    isError: false,
    errorName: "",
    inputValue: "",
    subText: ""
  }],
  partialLinkPayments: null,
  triggerJSCheckout: false,
  maxTxnAmount: null,
  partialPayment: false,
  partialAmountData: {
    isPartialPayment: false,
    paidAmount: "",
    blockAmount: "",
    payableAmount: "",
    totalAmount: "99",
    partialLinkPayments: null
  }
};
module.exports = { flexibleAmount: flexibleAmount, fixedAmount: fixedAmount, allAmountFields: allAmountFields, dropDownAmountField: dropDownAmountField };

/***/ }),

/***/ "BMrJ":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var memoize = function memoize(fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = function (fn) {
	var memo = {};

	return function (selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector];
	};
}(function (target) {
	return document.querySelector(target);
});

var singleton = null;
var singletonCounter = 0;
var stylesInsertedAtTop = [];

var fixUrls = __webpack_require__("DRTY");

module.exports = function (list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if (newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if (domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j]();
				}delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if (domStyle) {
			domStyle.refs++;

			for (var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for (; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for (var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = { css: css, media: media, sourceMap: sourceMap };

		if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement(options, style) {
	var target = getElement(options.insertInto);

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if (idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement(options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs(el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
		result = options.transform(obj.css);

		if (result) {
			// If transform returns a value, use that instead of the original css.
			// This allows running runtime transformations on the css.
			obj.css = result;
		} else {
			// If the transform function returns a falsy value, don't add this css.
			// This allows conditional loading of css
			return function () {
				// noop
			};
		}
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function remove() {
			removeStyleElement(style);

			if (style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function remove() {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if (newObj) {
			if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
}();

function applyToSingletonTag(style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag(style, obj) {
	var css = obj.css;
	var media = obj.media;

	if (media) {
		style.setAttribute("media", media);
	}

	if (style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while (style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink(link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
 	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
 	and there is no publicPath defined then lets turn convertToAbsoluteUrls
 	on by default.  Otherwise default to the convertToAbsoluteUrls option
 	directly
 */
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if (oldSrc) URL.revokeObjectURL(oldSrc);
}

/***/ }),

/***/ "DRTY":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),

/***/ "DudR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rupee-sign":"_3HD-","has-val":"_eI4F","pos-r":"_3bIa","amt-label":"_1lmX","ibl":"_1HgQ","tr":"_3zLd","clear":"_2zvE","ib":"_39Fc"};

/***/ }),

/***/ "FHM5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rupee-sign":"_1kxM","has-val":"_2K3F","pos-r":"_24XP","radio":"_XcID","wraper-type":"_2jru","select-head":"_CLun","radio-inp":"_2T0I","amt-section":"_23Ww"};

/***/ }),

/***/ "G1eP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
    require('preact/devtools');
} else if (false) {
    navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
    return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("PjlY"));

if (typeof app === 'function') {
    var root = document.body.firstElementChild;

    var init = function init() {
        var app = interopDefault(__webpack_require__("PjlY"));
        root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
    };

    if (false) module.hot.accept('preact-cli-entrypoint', init);
    init();
}

/***/ }),

/***/ "K/zd":
/***/ (function(module, exports) {

var data = {
    "resultInfo": null,
    "linkId": 657938771,
    "merchantId": "eNahCA88522718176395",
    "merchantName": "MENTOR KNOWLEDGE MANAGEMENT PRIVATE LIMITED",
    "imageName": null,
    "imageData": null,
    "linkDescription": "SASTP - 01",
    "linkName": "69967",
    "amount": null,
    "amountMantissa": null,
    "amountExponent": null,
    "expiryDate": "21 Oct, 2024",
    "status": "PENDING",
    "longUrl": "https://securegw.paytm.in/link/paymentForm/69967/LL_657938771",
    "shortUrl": "https://paytm.me/eHm-Wlc",
    "smartPhone": false,
    "customerName": null,
    "customerPhoneNo": null,
    "customerEmail": null,
    "templateInfo": "SASTP - 01\n11 Study Abroad Services From Admission to Arrival\n\nAdmission Application, Scholarships, Education Loan, Visa Cover Letter, Interview Preparation, Accommodation\n\nStudy Abroad Like A Pro!",
    "paidAmount": null,
    "blockAmount": null,
    "isPartialPayment": false,
    "payableAmount": null,
    "fields": [{
        "name": "First Name",
        "type": "Text",
        "displayText": "",
        "helpText": "",
        "orientation": "H",
        "mandatory": true,
        "size": 100,
        "constraints": {
            "maxLength": "30",
            "minLength": "3",
            "isMandatoryValidation": true,
            "validationType": "textValidation"
        },
        "parentField": "Full Name",
        "placeholder": "First Name*",
        "isError": false,
        "errorName": "",
        "inputValue": "",
        "subText": ""
    }, {
        "name": "Last Name",
        "type": "Text",
        "displayText": "",
        "helpText": "",
        "orientation": "H",
        "mandatory": true,
        "size": 100,
        "constraints": {
            "maxLength": "30",
            "minLength": "3",
            "isMandatoryValidation": true,
            "validationType": "textValidation"
        },
        "parentField": "Full Name",
        "placeholder": "Last Name*",
        "isError": false,
        "errorName": "",
        "inputValue": "",
        "subText": ""
    }, {
        "name": "Mobile Number",
        "type": "Numeric",
        "displayText": "",
        "helpText": "",
        "orientation": "H",
        "mandatory": true,
        "size": 100,
        "constraints": {
            "maxLength": "10",
            "minLength": "10",
            "isMandatoryValidation": true,
            "validationType": "numberValidation"
        },
        "placeholder": "Mobile Number*",
        "isError": false,
        "errorName": "",
        "inputValue": "",
        "subText": ""
    }, {
        "name": "Email ID",
        "type": "Text",
        "displayText": "",
        "helpText": "",
        "orientation": "H",
        "mandatory": true,
        "size": 100,
        "constraints": {
            "maxLength": "200",
            "minLength": "3",
            "isMandatoryValidation": true,
            "validationType": "textValidation"
        },
        "placeholder": "Email ID*",
        "isError": false,
        "errorName": "",
        "inputValue": "",
        "subText": ""
    }, {
        "name": "Region/Area",
        "type": "Text",
        "displayText": "",
        "helpText": "City and Area",
        "orientation": "H",
        "mandatory": true,
        "size": 100,
        "constraints": {
            "maxLength": 200,
            "minLength": 3,
            "isMandatoryValidation": true,
            "validationType": "textValidation"
        },
        "subText": "City and Area",
        "placeholder": "Region/Area*",
        "isError": false,
        "errorName": "",
        "inputValue": ""
    }, {
        "name": "Application Start Date",
        "type": "Date",
        "displayText": "",
        "helpText": "If you wish to start applying at a later date",
        "orientation": "H",
        "mandatory": true,
        "size": 100,
        "constraints": {
            "minValue": "23/10/2023",
            "maxValue": "24/10/2024",
            "isMandatoryValidation": true,
            "validationType": "dateValidation"
        },
        "subText": "If you wish to start applying at a later date",
        "placeholder": "Application Start Date*",
        "isError": false,
        "errorName": "",
        "inputValue": ""
    }, {
        "name": "SASTP - 01",
        "type": "Amount",
        "displayText": "",
        "helpText": "Inclusive of GST",
        "orientation": "H",
        "mandatory": true,
        "size": 100,
        "constraints": {
            "value": "1",
            "minValue": "0",
            "maxValue": "10000000",
            "isMandatoryValidation": true,
            "validationType": "numberValidation"
        },
        "subText": "Inclusive of GST",
        "placeholder": "SASTP - 01*",
        "isError": false,
        "errorName": "",
        "inputValue": "1"
    }],
    "partialLinkPayments": null,
    "triggerJSCheckout": false,
    "maxTxnAmount": null,
    "partialPayment": false,
    "partialAmountData": {
        "isPartialPayment": false,
        "paidAmount": "",
        "blockAmount": "",
        "payableAmount": "",
        "totalAmount": "",
        "partialLinkPayments": null
    }
};

module.exports = data;

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "LnyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18nUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__("ocZ9");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var I18NUtils = function (_Component) {
  _inherits(I18NUtils, _Component);

  function I18NUtils() {
    var _temp, _this, _ret;

    _classCallCheck(this, I18NUtils);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.i18n = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  I18NUtils.prototype.getKey = function getKey(key) {
    if (__WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].isNullOrUndefined(key)) return "";

    var msg = key.split(/\.(.+)/);
    /*
        if(!this.i18n[msg[0]]){
        //do async handling
        this.loadBundle(msg[0]);
        }
        */
    var a = this.i18n[msg[0]];
    return a && a[msg[1]] || !1;
  };

  I18NUtils.prototype.load = function load(data) {
    this.i18n = data;
  };

  return I18NUtils;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var i18nUtils = new I18NUtils();
var locale = i18nUtils.getKey.bind(i18nUtils);

/***/ }),

/***/ "NCO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export debounce */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isNumber; });
/* unused harmony export mobileValidation */
/* unused harmony export showCountryCode */
/* unused harmony export mobileNumberFormatSpace */
/* unused harmony export mobileNumberFormatNumber */
/* unused harmony export OTPMaxLengthCheck */
/* unused harmony export isValidMobileNumber */
/* unused harmony export isValidEmail */
/* unused harmony export userAgent */
/* unused harmony export toPascalCase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return numberWithCommas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatTotalAmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return numberWithoutCommas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getKey; });
/* unused harmony export getMonthNameDate */
/* unused harmony export getQueryParams */
/* unused harmony export convertRupeeCharToUnicode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__("ocZ9");
var _this = this;




var debounce = function debounce(func, delay) {
  var timer = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = _this;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      console.log("called");
      func.apply(context, args);
    }, delay);
  };
};

var formatDate = function formatDate(format, date) {
  var formattedDate = "";
  if (format && date) {
    switch (format) {
      case "DD/MM/YYYY":
        {
          formattedDate = dateInDDMMYYYY(date, "/");
          break;
        }
      case "DD-MM-YYYY":
        {
          formattedDate = dateInDDMMYYYY(date, "-");
          break;
        }
    }
  }
  return formattedDate;
};
var toDate = function toDate(dateStr) {
  if (dateStr) {
    var parts = dateStr.split(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].DATE_ORDINAL);
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }
  return false;
};
var dateInDDMMYYYY = function dateInDDMMYYYY(date, symbol) {
  symbol = symbol || __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].DATE_ORDINAL;
  date = new Date(date) || new Date();
  var dd = date.getDate();
  var mm = date.getMonth() + 1; // January is 0!

  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return "" + dd + symbol + mm + symbol + yyyy;
};

var isNumber = function isNumber(e) {
  if (!e) return false;
  if (typeof e !== "object" && /^\d+$/.test(e)) return true;

  var digit = String.fromCharCode(e.which);
  if (e.key !== undefined) {
    digit = e.key;
  }
  // any other character than digit
  if (!/^\d+$/.test(digit)) {
    // allow backspace, tab and right/left arrow
    if (e.which !== 8 && e.which !== 9 && e.which !== 37 && e.which !== 39) {
      return false;
    }
  }
  return true;
};

var mobileValidation = function mobileValidation(event) {
  var rgx = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].MOBILE_REG_EX;
  if (event) {
    if (event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 9) return true;
    if (event.target) {
      var value = event.target.value.replace(/[^0-9]/g, "");
      var digit = String.fromCharCode(event.which);
      if (event && event.target && !value && digit !== undefined && digit < 6) {
        event.target.value = "";
        return false;
      }

      if (value.length < 10 && (rgx.test(event.key) || value.length >= 1 && rgx.test(value))) {
        return true;
      }
      if (event.keyCode === 8) {
        return true;
      }
      return false;
    }
  }
};
var showCountryCode = function showCountryCode(event) {
  if (event.target && event.target.value.length > 0) {
    return true;
  }
  return false;
};

var mobileNumberFormatSpace = function mobileNumberFormatSpace(val) {
  val = val ? val.replace(/[^0-9]/g, "") : "";
  if (val.length >= 6) {
    return val.substring(0, 5) + " " + val.substring(5, 10);
  }
  return val;
};

var mobileNumberFormatNumber = function mobileNumberFormatNumber(val) {
  return val ? val.replace(/[^0-9]/g, "") : "";
};

var OTPMaxLengthCheck = function OTPMaxLengthCheck() {
  if (event && event.target && event.target.value) {
    event.target.value = event.target.value.replace(/[^0-9]/g, "").slice(0, 6);
  }
};

var isValidMobileNumber = function isValidMobileNumber(val) {
  var rgx = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].MOBILE_REG_EX;
  return rgx.test(val);
};

var isValidEmail = function isValidEmail(val) {
  var rgx = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].EMAIL_REG_EX;
  if (val) {
    return rgx.test(val);
  }
  return false;
};

var userAgent = function userAgent() {
  var mobileOrDesktop = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].USER_AGENT_MOBILE;
  if (window && window.navigator) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
      mobileOrDesktop = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].USER_AGENT_MOBILE;
    } else {
      mobileOrDesktop = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].USER_AGENT_WEB;
    }
  }
  return mobileOrDesktop;
};
var toPascalCase = function toPascalCase(word) {
  var words = word.toLowerCase().split(" ");
  var capitalizedWords = words.map(function (w) {
    return w.charAt(0).toUpperCase() + w.slice(1);
  });
  return capitalizedWords.join(" ");
};

var numberWithCommas = function numberWithCommas(x) {
  var skipLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (__WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].isNullOrUndefined(x)) {
    return "";
  }
  var numbers = x.toString().split(".");
  var output = "";
  if (numbers.length >= 1) {
    numbers[0] = numbers[0].replace(/[^0-9]/g, "");
    numbers[0] = isNaN(parseInt(numbers[0])) ? "" : parseInt(numbers[0]);
    if (numbers[0]) {
      if (!skipLimit && numbers[0] >= 100000000) {
        numbers[0] = parseInt(("" + numbers[0]).substring(0, 8));
      }
      if (window.Number && window.Number.prototype.toLocaleString) {
        output = numbers[0].toLocaleString("en-in");
      } else {
        output = numbers[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  }
  if (numbers.length >= 2) {
    if (numbers[1]) {
      numbers[1] = numbers[1].toString().replace(/[^0-9]/g, "");
    }
    numbers[1] = (numbers[1] + "0").toString().substring(0, 2);
    if (/^[0]+$/.test(numbers[1])) {
      return output;
    }
    output = output + "." + numbers[1];
  }
  if (output && output < 1) {
    output = parseFloat(output).toString();
  }
  return output;
};

var formatTotalAmount = function formatTotalAmount(x) {
  if (__WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].isNullOrUndefined(x)) {
    return "";
  }
  var numbers = x.toString().split(".");
  var output = "";
  if (numbers.length >= 1) {
    numbers[0] = numbers[0].replace(/[^0-9]/g, "");
    numbers[0] = isNaN(parseInt(numbers[0])) ? "" : parseInt(numbers[0]);
    if (numbers[0]) {
      if (window.Number && window.Number.prototype.toLocaleString) {
        output = numbers[0].toLocaleString("en-in");
      } else {
        output = numbers[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  }
  if (numbers.length >= 2) {
    if (numbers[1]) {
      numbers[1] = numbers[1].toString().replace(/[^0-9]/g, "");
    }
    output = output + "." + numbers[1].substring(0, 2);
  }
  if (output && output < 1) {
    output = parseFloat(output).toString();
  }
  return output;
};

var numberWithoutCommas = function numberWithoutCommas(number) {
  if (__WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].isNullOrUndefined(number)) {
    return "";
  }
  return number.replace(/,/g, "");
};

/**
 * obj is the object in which you want to find the key
 * path is the key you want to find
 * default value is the one which you want to return if no value is found
 */
var getKey = function getKey(obj, path, defaultValue) {
  var result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce(function (res, key) {
    return res !== null && res !== undefined ? res[key] : res;
  }, obj);
  return result === undefined || result === obj ? defaultValue : result;
};

var getMonthNameDate = function getMonthNameDate(inputDate) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].DMY_FORMAT;
  var monthType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "full";

  var date = inputDate.split("/");
  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  if (date.length === 3) {
    var day = Number(date[0]);
    var year = date[2];
    var month = monthType === "short" ? monthNames[date[1] - 1].substring(0, 3) : monthNames[date[1] - 1];
    if (format === __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].YMD_FORMAT) {
      year = date[0];

      day = Number(date[2]);
    }
    return day + " " + month + " " + year;
  }
  return "";
};

var getQueryParams = function getQueryParams(params, url) {
  try {
    var href = url;
    var reg = new RegExp("[?&]" + params + "=([^&#]*)", "i");
    var queryString = reg.exec(href);
    return queryString ? decodeURIComponent(queryString[1]) : null;
  } catch (e) {
    return null;
  }
};

var convertRupeeCharToUnicode = function convertRupeeCharToUnicode(text) {
  var rupeeUnicode = String.fromCodePoint(0x20b9);
  return (text || '').replace(/₹/g, rupeeUnicode);
};

/***/ }),

/***/ "PjlY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./form/style/index.css
var style = __webpack_require__("/VeU");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./form/components/merchantinfo/style.css
var merchantinfo_style = __webpack_require__("yRZD");
var merchantinfo_style_default = /*#__PURE__*/__webpack_require__.n(merchantinfo_style);

// EXTERNAL MODULE: ./utils/i18n.js
var i18n = __webpack_require__("LnyB");

// EXTERNAL MODULE: ./utils/utility.js
var utility = __webpack_require__("NCO4");

// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./form/components/async/amount-details/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function(require) {
				cb(__webpack_require__("5vbG"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var amount_details = (async_default()(load));
	
// EXTERNAL MODULE: ./utils/common.js
var common = __webpack_require__("ocZ9");

// CONCATENATED MODULE: ./form/components/merchantinfo/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var merchantinfo_MerchantInfo = function (_Component) {
  _inherits(MerchantInfo, _Component);

  function MerchantInfo() {
    _classCallCheck(this, MerchantInfo);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.toggleAmountDetailsPopUp = function () {
      if (_this.state.showAmountDetails) {
        common["a" /* default */].removeClassFromBody("hasPopupFixed");
      } else {
        common["a" /* default */].addClassOnBody("hasPopupFixed");
      }
      _this.setState(function (prevState) {
        return { showAmountDetails: !prevState.showAmountDetails };
      });
    };

    _this.state = { showAmountDetails: false };
    return _this;
  }

  MerchantInfo.prototype.render = function render(_ref, _ref2) {
    var logoURL = _ref.logoURL,
        buttonAmount = _ref.buttonAmount,
        name = _ref.name,
        linkDescription = _ref.linkDescription,
        partialAmountData = _ref.partialAmountData;
    var showAmountDetails = _ref2.showAmountDetails;

    return Object(preact_min["h"])(
      "div",
      null,
      logoURL && Object(preact_min["h"])(
        "div",
        { className: merchantinfo_style_default.a["m-hidelogo"] },
        Object(preact_min["h"])("img", { className: merchantinfo_style_default.a.mlogo, src: logoURL, alt: "img" })
      ),
      Object(preact_min["h"])(
        "div",
        { className: merchantinfo_style_default.a.header },
        logoURL && Object(preact_min["h"])(
          "div",
          { className: merchantinfo_style_default.a["w-hidelogo"] },
          Object(preact_min["h"])("img", { className: merchantinfo_style_default.a.wlogo, src: logoURL, alt: "img" })
        ),
        Object(preact_min["h"])(
          "div",
          { className: merchantinfo_style_default.a.ib },
          Object(preact_min["h"])(
            "h5",
            { className: merchantinfo_style_default.a.headertxt1 },
            Object(i18n["b" /* locale */])("link.pay"),
            (!!buttonAmount || partialAmountData && partialAmountData.isPartialPayment) && Object(preact_min["h"])(
              "span",
              { className: "float-r " + merchantinfo_style_default.a["fee-for"] + " " + merchantinfo_style_default.a["fee-for-pos"] + " " + merchantinfo_style_default.a["m-hide"] },
              Object(i18n["b" /* locale */])("link.amount.to.paid")
            )
          ),
          Object(preact_min["h"])(
            "h3",
            { className: merchantinfo_style_default.a.headertxt2 },
            Object(preact_min["h"])(
              "span",
              { className: merchantinfo_style_default.a["merc-name"] },
              name
            ),
            partialAmountData && !partialAmountData.isPartialPayment && !!buttonAmount && Object(preact_min["h"])(
              "span",
              { className: "float-r" },
              "\u20B9",
              Object(utility["b" /* formatTotalAmount */])(buttonAmount)
            ),
            partialAmountData && partialAmountData.isPartialPayment && Object(preact_min["h"])(
              "span",
              { className: "float-r" },
              "\u20B9",
              partialAmountData.payableAmount ? Object(utility["b" /* formatTotalAmount */])(partialAmountData.payableAmount) : "0.0",
              Number(partialAmountData.payableAmount) !== Number(partialAmountData.totalAmount) && Object(preact_min["h"])("span", { className: merchantinfo_style_default.a["down-arr"], onClick: this.toggleAmountDetailsPopUp })
            )
          ),
          linkDescription && Object(preact_min["h"])(
            "p",
            { className: merchantinfo_style_default.a["fee-for"] },
            linkDescription
          )
        )
      ),
      showAmountDetails && Object(preact_min["h"])(amount_details, {
        partialAmountData: partialAmountData,
        toggleAmountDetailsPopUp: this.toggleAmountDetailsPopUp
      })
    );
  };

  return MerchantInfo;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./form/components/button/style.css
var button_style = __webpack_require__("gbHb");
var button_style_default = /*#__PURE__*/__webpack_require__.n(button_style);

// CONCATENATED MODULE: ./form/components/button/index.js


function button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var button_Button = function (_Component) {
  button__inherits(Button, _Component);

  function Button() {
    button__classCallCheck(this, Button);

    return button__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Button.prototype.render = function render(_ref) {
    var buttonText = _ref.buttonText,
        type = _ref.type,
        disabled = _ref.disabled,
        showLoader = _ref.showLoader,
        buttonAmount = _ref.buttonAmount;

    type = type || "text";
    return Object(preact_min["h"])(
      "button",
      { type: type, className: button_style_default.a["submit-btn"] + " " + button_style_default.a["btn-primary"] + " ib", disabled: disabled },
      Object(preact_min["h"])(
        "span",
        { className: (showLoader ? button_style_default.a["hide-btn-text"] : "") + " " + button_style_default.a["btn-text"] },
        buttonText,
        " ",
        !!buttonAmount && Object(preact_min["h"])(
          "span",
          null,
          Object(preact_min["h"])(
            "span",
            { id: "rupee", className: "" + button_style_default.a["rupee-sign"] },
            "\u20B9"
          ),
          Object(utility["b" /* formatTotalAmount */])(buttonAmount)
        )
      ),
      showLoader && Object(preact_min["h"])(
        "div",
        { className: button_style_default.a.spinner + " " + button_style_default.a.proceedSpinner },
        Object(preact_min["h"])("div", { className: "" + button_style_default.a.bounce1 }),
        Object(preact_min["h"])("div", { className: "" + button_style_default.a.bounce2 }),
        Object(preact_min["h"])("div", { className: "" + button_style_default.a.bounce3 }),
        Object(preact_min["h"])("div", { className: "" + button_style_default.a.bounce4 }),
        Object(preact_min["h"])("div", { className: "" + button_style_default.a.bounce5 })
      )
    );
  };

  return Button;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// CONCATENATED MODULE: ./utils/formValidation.js





// export const validateFormFields = (data)=>{

//     const data = new FormData(form);
//     for(let name of data.keys())
//     {
//         const input = form.elements[name];
//         const dataValidators = input.dataset;
//         const value = data.get(name);
//         if(dataValidators.isMandatory)
//         {
//            let error =  _constant['INPUTVALIDATOR'][_constant['MANDATORY_VALIDATION']](value);
//             if(error)
//             {
//                 return {'error':true,'element':input};
//             }
//         }
//         if(dataValidators.fixed && dataValidators.validation)
//         {
//             let validationFucntion = dataValidators.validation;
//             let error = _constant['INPUTVALIDATOR'][validationFucntion](parseInt(dataValidators.fixed),value);
//             if(error)
//             {
//                 return {'error':error,'element':input};
//             }
//         }
//         else (dataValidators.validation)
//         {
//             const validationFucntion = dataValidators.validation;
//             let minVal = dataValidators.min?dataValidators.min:1;
//             let maxVal = dataValidators.max?dataValidators.max:1;
//             let error = _constant['INPUTVALIDATOR'][validationFucntion](parseInt(minVal),parseInt(maxVal),value);
//             if(error)
//             {
//                 return {'error':error,'element':input};
//             }
//         }
//     }

// }

var formValidation_validateFormFields = function validateFormFields(formData) {
  var data = formData || [];
  var length = data.length || 0;
  var isFormError = false;
  for (var i = 0; i < length; i++) {
    var field = data[i];
    if (field.constraints) {
      if (field.constraints.isMandatoryValidation) {
        if (common["a" /* default */].isNullOrUndefined(field.inputValue) || field.inputValue === "") {
          field.isError = true;
          field.errorName = (field.name ? field.name : "value") + " " + Object(i18n["b" /* locale */])("form.required.error");
          isFormError = true;
        } else if (formValidation_valuePresentValidations(field)) {
          isFormError = true;
        }
      } else if (!common["a" /* default */].isNullOrUndefined(field.inputValue) && field.inputValue !== "") {
        if (formValidation_valuePresentValidations(field)) {
          isFormError = true;
        }
      }
    }
  }
  return { fields: data, isFormError: isFormError };
};

var formValidation_valuePresentValidations = function valuePresentValidations(field) {
  var isError = false;
  if (constants["a" /* default */].INPUT_TEXT_REGEX.test(field.inputValue)) {
    field.isError = true;
    field.errorName = "" + Object(i18n["b" /* locale */])("form.not.valid.value");
    isError = true;
  }
  if (field.constraints && field.constraints.format && !new RegExp(field.constraints.format).test(field.inputValue)) {
    field.isError = true;
    field.errorName = "" + Object(i18n["b" /* locale */])("form.not.valid.value");
    isError = true;
  } else if (field.constraints && field.constraints.allowedValues && Array.isArray(field.constraints.allowedValues) && field.constraints.allowedValues.length > 0) {
    var isDropdownAmount = Object(utility["c" /* getKey */])(field, "type", null) === constants["a" /* default */].CUSTOM_AMOUNT_DROPDOWN;
    var isValue = null;
    if (isDropdownAmount) {
      isValue = field.constraints.allowedValues.find(function (item) {
        return field.inputValue == Object(utility["c" /* getKey */])(item, "name", null);
      });
    } else {
      isValue = field.constraints.allowedValues.find(function (item) {
        return field.inputValue == item;
      });
    }
    if (!isValue) {
      field.isError = true;
      field.errorName = "" + Object(i18n["b" /* locale */])("form.not.allowed.value");
      isError = true;
    }
  } else {
    if (field.constraints && field.constraints.minValue && field.constraints.maxValue) {
      var min = field.constraints.minValue;
      var max = field.constraints.maxValue;
      var value = field.inputValue;
      if (field.type && field.type == constants["a" /* default */].CUSTOM_DATE) {
        if (value && (new Date(Object(utility["g" /* toDate */])(value)) < new Date(Object(utility["g" /* toDate */])(min)) || new Date(Object(utility["g" /* toDate */])(value)) > new Date(Object(utility["g" /* toDate */])(max)))) {
          field.isError = true;
          field.errorName = (field.name ? field.name : "value") + " " + Object(i18n["b" /* locale */])("form.can.be.between") + " " + min + " " + Object(i18n["b" /* locale */])("form.and") + " " + max;
          isError = true;
        }
      } else if (value && (Number(value) < Number(min) || Number(value) > Number(max))) {
        field.isError = true;
        field.errorName = (field.name ? field.name : "value") + " " + Object(i18n["b" /* locale */])("form.can.be.between") + " " + min + " " + Object(i18n["b" /* locale */])("form.and") + " " + max;
        isError = true;
      }
    }
    if (field.constraints && field.constraints.minLength && field.constraints.maxLength) {
      var _min = field.constraints.minLength;
      var _max = field.constraints.maxLength;
      var _value = field.inputValue;
      // Fixed length case
      if (_min == _max) {
        if (_value && _value.length != _min) {
          field.isError = true;
          field.errorName = (field.name ? field.name : "value") + " " + Object(i18n["b" /* locale */])("form.fixed.length") + " " + _min;
          isError = true;
        }
      } else if (_value && (_value.length < _min || _value.length > _max)) {
        field.isError = true;
        field.errorName = (field.name ? field.name : "value") + " " + Object(i18n["b" /* locale */])("form.can.be.from") + " " + _min + " " + Object(i18n["b" /* locale */])("form.to") + " " + _max + " " + Object(i18n["b" /* locale */])("form.character");
        isError = true;
      }
    }
  }
  return isError;
};
// CONCATENATED MODULE: ./utils/http.js
var payload = function payload(data) {
  return {
    head: {
      clientId: "",
      version: "",
      timestamp: new Date().getTime(),
      channelId: "WEB",
      tokenType: "",
      signature: ""
    },
    body: data
  };
};
var post = function post(url, data) {
  data = payload(data);
  return fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    credentials: "same-origin",
    body: JSON.stringify(data)
  }).then(function (response) {
    return response.json();
  }).then(function (res) {
    if (res && res.body) {
      return new Promise(function (resolve, reject) {
        if (res.body.resultInfo.resultStatus === "SUCCESS" || res.body.resultInfo.status === "SUCCESS") {
          resolve(res);
        } else {
          reject(res);
        }
      });
    }
    return Promise.reject(res);
  }).catch(function (error) {
    return Promise.reject(error);
  });
};

var customPost = function customPost(url, data) {
  return fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    credentials: "same-origin",
    body: JSON.stringify(data)
  }).then(function (response) {
    return response.json();
  }).then(function (res) {
    if (res.status) {
      return new Promise(function (resolve, reject) {
        if (res.status === "SUCCESS") {
          resolve(res);
        } else {
          reject(res);
        }
      });
    }
    return Promise.reject(res);
  }).catch(function (error) {
    return Promise.reject(error);
  });
};
// EXTERNAL MODULE: ./form/components/paymentfields/style.css
var paymentfields_style = __webpack_require__("VHod");
var paymentfields_style_default = /*#__PURE__*/__webpack_require__.n(paymentfields_style);

// EXTERNAL MODULE: ./utils/logger.js
var logger = __webpack_require__("cxRM");

// EXTERNAL MODULE: ./form/components/inputs/default-amount/style.css
var default_amount_style = __webpack_require__("DudR");
var default_amount_style_default = /*#__PURE__*/__webpack_require__.n(default_amount_style);

// CONCATENATED MODULE: ./form/components/inputs/default-amount/index.js


function default_amount__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function default_amount__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function default_amount__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var default_amount_DefaultAmountInput = function (_Component) {
  default_amount__inherits(DefaultAmountInput, _Component);

  function DefaultAmountInput() {
    default_amount__classCallCheck(this, DefaultAmountInput);

    return default_amount__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  DefaultAmountInput.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  DefaultAmountInput.prototype.render = function render(_ref) {
    var inputValue = _ref.inputValue;

    return Object(preact_min["h"])(
      "div",
      { className: default_amount_style_default.a.clear + " " + default_amount_style_default.a["pos-r"] },
      Object(preact_min["h"])(
        "div",
        { className: default_amount_style_default.a["amt-label"] + " " + default_amount_style_default.a.ibl },
        "Amount"
      ),
      Object(preact_min["h"])(
        "div",
        { className: default_amount_style_default.a["amt-label"] + " " + default_amount_style_default.a.ibl + " " + default_amount_style_default.a.tr },
        Object(preact_min["h"])(
          "span",
          { className: "" + default_amount_style_default.a["rupee-sign"] },
          "\u20B9"
        ),
        Object(utility["e" /* numberWithCommas */])(inputValue)
      )
    );
  };

  return DefaultAmountInput;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../config/dev.js
var dev = __webpack_require__("uAm5");
var dev_default = /*#__PURE__*/__webpack_require__.n(dev);

// CONCATENATED MODULE: ./utils/checkout.js


var mConfig = {
  root: "#paytm-checkoutjs",
  backButton: true,
  style: {
    // borderColor: "",
    // bodyBackgroundColor: "#ffffff",
    // bodyColor: "#182233",
    // themeBackgroundColor: "#2073d4",
    // themeColor: "#ffffff",
    // headerBackgroundColor: "#F5F9FE",
    // headerColor: "#F5F9FE",
    // errorColor: "",
    // successColor: "",
    // card: {
    //   padding: "",
    //   backgroundColor: ""
    // }
  },
  flow: "DEFAULT",
  redirectionEnabled: true,
  redirect: true,
  labels: {},
  isGradientEffectEnable: false,
  data: {
    orderId: "",
    token: "",
    tokenType: "TXN_TOKEN",
    amount: ""
  },
  merchant: { redirect: true, hidePaytmBranding: false },
  handler: {
    notifyMerchant: function notifyMerchant(eventType, data) {
      console.log("notify merchant called", eventType, data);
    }
  }
};

var buildPayload = function buildPayload(payload) {
  var body = payload.body;

  return JSON.stringify({
    head: {
      timestamp: "1539601338741",
      clientId: "78yds87ty7ds",
      version: "v2",
      channelId: "WEB",
      // tokenType: "AES" | "JWT",
      tokenType: "AES",
      signature: "jhddyt87td87vd"
    },
    body: body
  });
};

var generateTxnToken = function generateTxnToken(url, payload) {
  return fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    credentials: "same-origin",
    body: buildPayload(payload)
  }).then(function (resp) {
    return resp.json();
  }).then(function (jsonResp) {
    return new Promise(function (resolve, reject) {
      if (jsonResp) {
        resolve(jsonResp);
      } else {
        reject(jsonResp);
      }
    });
  }).catch(function (error) {
    console.log(error);
    return Promise.reject(error);
  });
};
// CONCATENATED MODULE: ./form/components/paymentfields/index.js


function paymentfields__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function paymentfields__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function paymentfields__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var paymentfields_PaymentFields = function (_Component) {
  paymentfields__inherits(PaymentFields, _Component);

  function PaymentFields(props) {
    paymentfields__classCallCheck(this, PaymentFields);

    var _this = paymentfields__possibleConstructorReturn(this, _Component.call(this, props));

    _this.setInputFields = function (fields, getFormFields) {
      _this.inputFields = [];
      var length = fields.length || 0;
      var element = [];
      for (var i = 0; i < fields.length; i++) {
        if (!(_this.props.partialAmountData && _this.props.partialAmountData.isPartialPayment) && i === _this.amountFieldFirtsIndex && _this.props.amount) {
          _this.inputFields.push(Object(preact_min["h"])(
            "div",
            { className: "ib w100 pos-r" },
            Object(preact_min["h"])(
              "div",
              { className: "custom-length", style: "width:100%" },
              Object(preact_min["h"])(
                "div",
                { className: "spacer" },
                Object(preact_min["h"])(
                  "li",
                  null,
                  Object(preact_min["h"])(default_amount_DefaultAmountInput, { inputValue: _this.props.amount })
                )
              )
            )
          ));
        }
        var field = fields[i];
        element.push(getFormFields(field.inputValue, field.isError, field.errorName, field.type, field.name, field.constraints, field.placeholder, field.subText, i, field.size, _this.updateFormValue, _this.clearErrorData, _this.props.updateAmount));
        if (field.parentSubText) {
          element.push(Object(preact_min["h"])(
            "p",
            { className: "input-info input-info-outer spacer" },
            field.parentSubText
          ));
        }
        if (i < length - 1 && fields[i + 1].orientation && fields[i + 1].orientation === constants["a" /* default */].H_ORIENTATION) {
          _this.inputFields.push(Object(preact_min["h"])(
            "li",
            null,
            element
          ));
          element = [];
        } else if (i === length - 1) {
          _this.inputFields.push(Object(preact_min["h"])(
            "li",
            null,
            element
          ));
          element = [];
        }
      }
    };

    _this.updateFormValue = function (index, value) {
      _this.clearPaymentFormError();
      var fields = _this.state.fields || [];
      if (fields.length > 0 && index < fields.length) {
        if (fields[index].inputValue !== undefined) {
          fields[index].inputValue = value;
          _this.setState(function () {
            return { fields: fields };
          });
          _this.setInputFields(_this.state.fields, _this.props.getFormFields);
        }
      }
    };

    _this.clearErrorData = function (index) {
      var fields = _this.state.fields || [];
      if (fields.length > 0 && index < fields.length) {
        if (fields[index].inputValue !== undefined) {
          fields[index].isError = false;
          fields[index].errorName = "";
          _this.setState(function () {
            return { fields: fields };
          });
          _this.setInputFields(_this.state.fields, _this.props.getFormFields);
        }
      }
    };

    _this.submitPaymentForm = function (e) {
      e.preventDefault();
      if (_this.state.buttonDisabled) {
        return;
      }
      if (_this.props.showPayLimitExceedError) {
        return;
      }
      _this.clearPaymentFormError();
      var errorData = formValidation_validateFormFields(_this.state.fields);
      if (errorData.isFormError) {
        _this.setState({ fields: errorData.fields });
        _this.setInputFields(_this.state.fields, _this.props.getFormFields);
        Object(logger["b" /* logEvent */])({
          eventType: "Form_Validation_Failed",
          eventValue: "form field error",
          data: errorData.fields.map(function (item) {
            return {
              fieldName: item.name,
              isError: item.isError,
              errorName: item.errorName,
              constraints: item.constraints
            };
          })
        });
      } else {
        _this.setState({ showButtonLoader: true, buttonDisabled: true });
        var formData = { fields: [], linkId: _this.props.linkId ? _this.props.linkId : "" };
        if (_this.amountFieldFirtsIndex !== -1) {
          formData.totalAmount = _this.props.buttonAmount;
        }
        formData.mid = _this.props.mid;
        formData.fields = common["a" /* default */].setPostPaymentFormData(_this.state.fields);
        Object(logger["b" /* logEvent */])({ eventType: "Proceed_to_Pay", eventValue: "Submit form Button click" });
        Object(logger["b" /* logEvent */])({
          eventType: "Payment_Form_submit",
          eventValue: "Validation success",
          data: _this.state.fields.map(function (item) {
            return { fieldName: item.name };
          })
        });
        // common.invokeCheckoutJS(config);
        var loader = document.getElementById("ptm-loader");
        post(common["a" /* default */].getAPIHOST() + "/" + constants["a" /* default */].PAYMENT_FORM_SUBMIT_URL, formData).then(function (data) {
          _this.setState({ showButtonLoader: false, buttonDisabled: false });
          Object(logger["b" /* logEvent */])({ eventType: "Post_Form_Submit", eventValue: "API success", status: "success" });

          var triggerJSCheckout = Object(utility["c" /* getKey */])(_this.props, "triggerJSCheckout", undefined);
          if (triggerJSCheckout) {
            loader.style.display = "block";
            var config = mConfig || {};
            config.data.token = Object(utility["c" /* getKey */])(data, "body.txnToken", undefined);
            config.data.orderId = Object(utility["c" /* getKey */])(data, "body.orderId", undefined);
            config.data.amount = Object(utility["c" /* getKey */])(_this.props, "amount", "");
            _this.props.showCheckoutJS();
            common["a" /* default */].invokeCheckoutJS(config).then(function (result) {
              if (result) {
                loader.style.display = "none";
                _this.props.toggleCheckoutjsLoader();
              }
            }).catch(function (error) {
              loader.style.display = "none";
              console.log({ error: error });
            });
          } else if (data.body.paymentLink) {
            var url = common["a" /* default */].isWebView() && Object(utility["c" /* getKey */])(data, "body.longUrl", "") ? Object(utility["c" /* getKey */])(data, "body.longUrl", "") : Object(utility["c" /* getKey */])(data, "body.paymentLink", "");
            common["a" /* default */].redirectToURL(url);
          }
        }).catch(function (error) {
          var errorMsg = "";
          _this.setState({ showButtonLoader: false, buttonDisabled: false });
          if (error && error.body) {
            if (error.body.hasOwnProperty("errorFields") && error.body.errorFields) {
              var fields = _this.state.fields;
              var errorFields = error.body.errorFields;

              var _loop = function _loop(fieldName) {
                var errorFieldIndex = fields.findIndex(function (item) {
                  return item.name == fieldName;
                });
                if (errorFieldIndex > -1) {
                  fields[errorFieldIndex].errorName = errorFields[fieldName];
                  fields[errorFieldIndex].isError = true;
                  _this.setState({ fields: fields });
                  _this.setInputFields(_this.state.fields, _this.props.getFormFields);
                }
              };

              for (var fieldName in errorFields) {
                _loop(fieldName);
              }
            }
            if (error.body.resultInfo && error.body.resultInfo.resultStatus && error.body.resultInfo.resultMessage) {
              errorMsg = error.body.resultInfo.resultMessage;
            }
          } else {
            errorMsg = Object(i18n["b" /* locale */])("error.something.went.wrong");
          }
          _this.setState({
            showPaymentFormError: true,
            PaymentFormError: errorMsg
          });
          Object(logger["b" /* logEvent */])({ eventType: "Post_Form_Submit", eventValue: "API failed", error: errorMsg });
        });
      }
      // fields.map((field,index)=>{
      //     return getFormFields(field.type,field.name,field.constraints,field.placeholder,field.subtext,index,field.orientation,field.size);
      // })
    };

    _this.clearPaymentFormError = function () {
      _this.setState({ PaymentFormError: "", showPaymentFormError: false });
    };

    _this.inputFields = [];
    _this.state = {
      fields: props.fields,
      showPaymentFormError: false,
      PaymentFormError: "",
      showButtonLoader: false,
      buttonDisabled: false
    };
    _this.amountFieldFirtsIndex = common["a" /* default */].getAmountFieldFirtsIndex(_this.state.fields);
    _this.setInputFields(_this.state.fields, props.getFormFields);
    _this.updateFormValue = _this.updateFormValue.bind(_this);
    _this.clearPaymentFormError = _this.clearPaymentFormError.bind(_this);
    return _this;
  }

  PaymentFields.prototype.render = function render(_ref) {
    var templateInfo = _ref.templateInfo,
        buttonAmount = _ref.buttonAmount;

    return Object(preact_min["h"])(
      "div",
      { className: "main ib" },
      Object(preact_min["h"])(
        "p",
        { className: "" + paymentfields_style_default.a["product-info"] },
        templateInfo
      ),
      Object(preact_min["h"])(
        "form",
        { id: "paymentForm", "data-isMob": "dfs", "data-isemail": "dfs", onSubmit: this.submitPaymentForm },
        Object(preact_min["h"])(
          "ul",
          { className: "" + paymentfields_style_default.a["input-list"] },
          this.inputFields
        ),
        Object(preact_min["h"])(
          "div",
          { className: "ib " + paymentfields_style_default.a.payBtn },
          this.state.showPaymentFormError && Object(preact_min["h"])(
            "div",
            { className: "error form-error" },
            this.state.PaymentFormError
          ),
          this.props.showPayLimitExceedError && Object(preact_min["h"])(
            "div",
            { className: "error form-error" },
            this.props.payLimitExceedError
          ),
          Object(preact_min["h"])(button_Button, {
            type: "submit",
            buttonText: Object(i18n["b" /* locale */])("button.proceed.to.pay"),
            showLoader: this.state.showButtonLoader,
            disabled: this.state.buttonDisabled,
            buttonAmount: buttonAmount
          })
        )
      )
    );
  };

  return PaymentFields;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/util/util.js
var util = __webpack_require__("gfUn");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./form/components/inputs/number/index.js


function number__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function number__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function number__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var number_NumberInput = function (_Component) {
  number__inherits(NumberInput, _Component);

  function NumberInput(props) {
    number__classCallCheck(this, NumberInput);

    var _this = number__possibleConstructorReturn(this, _Component.call(this, props));

    _this.validateNumberInput = function (event) {
      if (!Object(utility["d" /* isNumber */])(event)) {
        Object(common["b" /* preventDefault */])(event);
        event.target.value = event.target.value.replace(constants["a" /* default */].NUMBER_REG_EX, "");
      }
    };

    _this.updateValue = function (event) {
      if (event && event.target) {
        _this.setState(function () {
          return { inputValue: event.target.value.trim() };
        });
        _this.props.updateFormValue(_this.props.index, _this.state.inputValue);
      }
    };

    _this.replaceChar = function (event) {
      if (!Object(utility["d" /* isNumber */])(event)) {
        event.target.value = event.target.value.replace(constants["a" /* default */].NUMBER_REG_EX, "");
      }
    };

    _this.clearErrors = function () {
      if (_this.state.isError && !Object(util["isNullOrUndefined"])(_this.props.index)) {
        _this.props.clearErrorData(_this.props.index);
      }
      Object(logger["b" /* logEvent */])({ eventType: "clicked_form_field", eventValue: "number form field", fieldName: _this.props.name });
    };

    _this.pasteNumber = function (event) {
      setTimeout(function () {
        if (event && event.target) {
          var number = event.target.value;
          if (Object(utility["d" /* isNumber */])(number)) {
            _this.setState(function () {
              return { inputValue: number.trim() };
            });
            _this.props.updateFormValue(_this.props.index, _this.state.inputValue);
          } else {
            event.target.value = "";
          }
        }
      }, 0);
    };

    _this.state = { isError: false, errorName: "", inputValue: "" };
    return _this;
  }

  NumberInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  };

  NumberInput.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (nextProps.inputValue == this.props.inputValue && nextProps.isError == this.props.isError && nextProps.errorName == this.props.errorName) {
      return false;
    }
  };

  NumberInput.prototype.render = function render(_ref) {
    var name = _ref.name,
        constraints = _ref.constraints,
        placeholder = _ref.placeholder,
        subText = _ref.subText;

    var maxLength = constraints.maxLength ? constraints.maxLength : "";
    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])("input", {
        name: name,
        type: "tel",
        value: this.state.inputValue,
        placeholder: placeholder,
        maxlength: maxLength,
        onKeyDown: this.validateNumberInput,
        onKeyUp: this.replaceChar,
        onChange: this.updateValue,
        onFocus: this.clearErrors,
        onPaste: this.pasteNumber,
        autocomplete: "off"
      }),
      subText && Object(preact_min["h"])(
        "p",
        { className: "input-info" },
        subText
      ),
      this.state.isError && Object(preact_min["h"])(
        "span",
        { className: "error " + (subText ? "sub-txt-err" : ""), "data-error-for": name },
        this.state.errorName
      )
    );
  };

  return NumberInput;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./form/components/inputs/text/index.js


function text__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function text__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function text__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var text_TextInput = function (_Component) {
  text__inherits(TextInput, _Component);

  function TextInput(props) {
    text__classCallCheck(this, TextInput);

    var _this = text__possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateValue = function (event) {
      if (event && event.target) {
        _this.setState({ inputValue: event.target.value.trim() });
        _this.props.updateFormValue(_this.props.index, _this.state.inputValue);
      }
    };

    _this.clearErrors = function () {
      if (_this.state.isError && !common["a" /* default */].isNullOrUndefined(_this.props.index)) {
        _this.props.clearErrorData(_this.props.index);
      }
      Object(logger["b" /* logEvent */])({ eventType: "clicked_form_field", eventValue: "text form field", fieldName: _this.props.name });
    };

    _this.state = { isError: false, errorName: "", inputValue: "" };
    return _this;
  }

  TextInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  };

  TextInput.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (nextProps.inputValue == this.props.inputValue && nextProps.isError == this.props.isError && nextProps.errorName == this.props.errorName) {
      return false;
    }
  };

  TextInput.prototype.render = function render(_ref) {
    var name = _ref.name,
        constraints = _ref.constraints,
        placeholder = _ref.placeholder,
        subText = _ref.subText;

    var maxLength = constraints.maxLength ? constraints.maxLength : "";
    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])("input", {
        name: name,
        type: "text",
        value: this.state.inputValue,
        placeholder: placeholder,
        maxlength: maxLength,
        onChange: this.updateValue,
        onFocus: this.clearErrors,
        autocomplete: "off"
      }),
      subText && Object(preact_min["h"])(
        "p",
        { className: "input-info" },
        subText
      ),
      this.state.isError && Object(preact_min["h"])(
        "span",
        { className: "error " + (subText ? "sub-txt-err" : ""), "data-error-for": name },
        this.state.errorName
      )
    );
  };

  return TextInput;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./form/components/inputs/list/style.css
var list_style = __webpack_require__("pcJx");
var list_style_default = /*#__PURE__*/__webpack_require__.n(list_style);

// CONCATENATED MODULE: ./form/components/inputs/list/index.js


function list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var list_ListInput = function (_Component) {
  list__inherits(ListInput, _Component);

  function ListInput(props) {
    list__classCallCheck(this, ListInput);

    var _this = list__possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateValue = function (event) {
      if (event && event.target) {
        _this.setState({ inputValue: event.target.value });
        _this.props.updateFormValue(_this.props.index, _this.state.inputValue);
      }
    };

    _this.clearErrors = function () {
      if (_this.state.isError && !Object(util["isNullOrUndefined"])(_this.props.index)) {
        _this.props.clearErrorData(_this.props.index);
      }
      Object(logger["b" /* logEvent */])({ eventType: "clicked_form_field", eventValue: "list form field", fieldName: _this.props.name });
    };

    _this.toggleDropDown = function () {
      _this.setState(function (prevState) {
        return { showDropDown: !prevState.showDropDown };
      });
    };

    _this.updateSelected = function (value) {
      if (value === _this.props.name) {
        _this.setState({ inputValue: "" });
        _this.props.updateFormValue(_this.props.index, "");
      } else {
        _this.setState({ inputValue: value });
        _this.props.updateFormValue(_this.props.index, _this.state.inputValue);
      }
      _this.toggleDropDown();
    };

    _this.getOption = function (options) {
      return options.map(function (name) {
        return Object(preact_min["h"])(
          "li",
          {
            className: list_style_default.a["select-item"] + " " + list_style_default.a["list-option"],
            onClick: function onClick() {
              _this.updateSelected(name);
            }
          },
          Object(preact_min["h"])(
            "span",
            { className: "" + list_style_default.a["select-txt"] },
            name
          )
        );
      });
    };

    _this.state = { isError: false, errorName: "Value is required", inputValue: "", showDropDown: false };
    _this.node = "";
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
    _this.handleDropdownClick = _this.handleDropdownClick.bind(_this);
    return _this;
  }

  ListInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  };

  ListInput.prototype.addCloseEvent = function addCloseEvent() {
    document.addEventListener("click", this.handleOutsideClick, false);
  };

  ListInput.prototype.removeCloseEvent = function removeCloseEvent() {
    document.removeEventListener("click", this.handleOutsideClick, false);
  };

  ListInput.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextSate) {
    if (nextProps.inputValue == this.props.inputValue && nextProps.isError == this.props.isError && nextProps.errorName == this.props.errorName && this.state.showDropDown == nextSate.showDropDown) {
      return false;
    }
  };

  ListInput.prototype.handleOutsideClick = function handleOutsideClick(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.removeCloseEvent();
    this.handleDropdownClick(e, true);
  };

  ListInput.prototype.handleDropdownClick = function handleDropdownClick(e) {
    var clickOutside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (clickOutside) {
      this.setState({ showDropDown: false });
      return;
    }
    if (!this.state.showDropDown) {
      this.addCloseEvent();
    } else {
      this.removeCloseEvent();
    }
    if (!clickOutside) {
      this.clearErrors();
    }
    this.toggleDropDown();
  };

  ListInput.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick, false);
  };

  ListInput.prototype.render = function render(_ref) {
    var _this2 = this;

    var name = _ref.name,
        constraints = _ref.constraints,
        placeholder = _ref.placeholder,
        subText = _ref.subText;

    return Object(preact_min["h"])(
      "div",
      { className: "pos-r mt10" },
      Object(preact_min["h"])(
        "div",
        {
          ref: function ref(node) {
            _this2.node = node;
          }
        },
        Object(preact_min["h"])(
          "div",
          { className: "" + list_style_default.a["select-head"], onClick: this.handleDropdownClick },
          placeholder && !this.state.inputValue && Object(preact_min["h"])(
            "span",
            { className: "" + list_style_default.a["select-para"] },
            placeholder
          ),
          !Object(util["isNullOrUndefined"])(this.state.inputValue) && Object(preact_min["h"])(
            "span",
            { className: "" + list_style_default.a["value-added"] },
            this.state.inputValue
          ),
          Object(preact_min["h"])(
            "span",
            { className: "" + list_style_default.a["drop-link"] },
            Object(preact_min["h"])("img", { src: common["a" /* default */].getStaticPath() + "/assets/ic-chevron-down.svg" })
          )
        ),
        Object(preact_min["h"])(
          "div",
          { className: list_style_default.a["select-dropdown"] + " " + (this.state.showDropDown ? list_style_default.a.visible : "") },
          Object(preact_min["h"])(
            "ul",
            { className: "" + list_style_default.a["select-list"] },
            this.getOption(constraints.allowedValues)
          )
        )
      ),
      subText && Object(preact_min["h"])(
        "p",
        { className: "input-info" },
        subText
      ),
      this.state.isError && Object(preact_min["h"])(
        "span",
        { className: "error " + (subText ? "sub-txt-err" : ""), "data-error-for": name },
        this.state.errorName
      )
    );
  };

  return ListInput;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./form/components/async/date-picker/index.js

		

		function date_picker_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function(require) {
				cb(__webpack_require__("V+JF"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var date_picker = (async_default()(date_picker_load));
	
// CONCATENATED MODULE: ./form/components/inputs/date/index.js


function date__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function date__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function date__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var date_DateInput = function (_Component) {
  date__inherits(DateInput, _Component);

  function DateInput(props) {
    date__classCallCheck(this, DateInput);

    var _this = date__possibleConstructorReturn(this, _Component.call(this, props));

    _this.getdisplayDates = function (maxDate) {
      if (maxDate) {
        var date = new Date(Object(utility["g" /* toDate */])(maxDate));
        if (date < new Date()) {
          return { month: date.getMonth(), year: date.getFullYear() };
        }
      }
      return { month: "", year: "" };
    };

    _this.updateValue = function (value) {
      _this.clearErrors();
      if (value) {
        _this.setState({ inputValue: value.trim() });
        _this.props.updateFormValue(_this.props.index, _this.state.inputValue);
      }
    };

    _this.clearErrors = function () {
      if (_this.state.isError && !Object(util["isNullOrUndefined"])(_this.props.index)) {
        _this.props.clearErrorData(_this.props.index);
      }
      Object(logger["b" /* logEvent */])({ eventType: "clicked_form_field", eventValue: "date form field", fieldName: _this.props.name });
    };

    _this.state = { isError: false, errorName: "Value is required", inputValue: "" };
    _this.updateValue = _this.updateValue.bind(_this);
    _this.clearErrors = _this.clearErrors.bind(_this);
    _this.dateFormat = "DD" + constants["a" /* default */].DATE_ORDINAL + "MM" + constants["a" /* default */].DATE_ORDINAL + "YYYY";
    return _this;
  }

  DateInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  };

  DateInput.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextSate) {
    if (nextSate.isError !== this.state.isError) {
      return true;
    }
    if (nextProps.inputValue == this.props.inputValue && nextProps.isError == this.props.isError && nextProps.errorName == this.props.errorName) {
      return false;
    }
  };

  DateInput.prototype.render = function render(_ref) {
    var name = _ref.name,
        constraints = _ref.constraints,
        placeholder = _ref.placeholder,
        subText = _ref.subText;

    var datePickerOptions = {
      selectedDate: "",
      minDate: constraints.minValue ? constraints.minValue : "",
      maxDate: constraints.maxValue ? constraints.maxValue : "",
      displayDate: this.getdisplayDates(constraints.maxValue)
    };
    return Object(preact_min["h"])(
      "div",
      { className: "pos-r" },
      Object(preact_min["h"])(date_picker, {
        minDate: datePickerOptions.minDate,
        maxDate: datePickerOptions.maxDate,
        selectedDate: datePickerOptions.selectedDate,
        datePickerOpened: false,
        dateInputFormat: this.dateFormat,
        showCalendarIcon: true,
        placeholder: placeholder,
        name: name,
        onDateChange: this.updateValue,
        onDateInputClick: this.clearErrors,
        displayedMonth: datePickerOptions.displayDate.month,
        displayedYear: datePickerOptions.displayDate.year
      }),
      subText && Object(preact_min["h"])(
        "p",
        { className: "input-info" },
        subText
      ),
      this.state.isError && Object(preact_min["h"])(
        "span",
        { className: "error " + (subText ? "sub-txt-err" : ""), "data-error-for": name },
        this.state.errorName
      )
    );
  };

  return DateInput;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./form/components/inputs/dropdown-amount/style.css
var dropdown_amount_style = __webpack_require__("kkOB");
var dropdown_amount_style_default = /*#__PURE__*/__webpack_require__.n(dropdown_amount_style);

// CONCATENATED MODULE: ./form/components/inputs/dropdown-amount/index.js


function dropdown_amount__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dropdown_amount__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function dropdown_amount__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var dropdown_amount_DropdownAmountInput = function (_Component) {
  dropdown_amount__inherits(DropdownAmountInput, _Component);

  function DropdownAmountInput(props) {
    dropdown_amount__classCallCheck(this, DropdownAmountInput);

    var _this = dropdown_amount__possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateValue = function (amt, name) {
      if (name === _this.props.name) {
        _this.props.updateFormValue(_this.props.index, "");
      } else {
        _this.props.updateFormValue(_this.props.index, name);
      }
      _this.props.updateAmount(Number(Object(utility["f" /* numberWithoutCommas */])(amt)));
    };

    _this.clearErrors = function () {
      if (_this.state.isError && !Object(util["isNullOrUndefined"])(_this.props.index)) {
        _this.props.clearErrorData(_this.props.index);
      }
      Object(logger["b" /* logEvent */])({ eventType: "clicked_form_field", eventValue: "list form field", fieldName: _this.props.name });
    };

    _this.toggleDropDown = function () {
      _this.setState(function (prevState) {
        return { showDropDown: !prevState.showDropDown };
      });
    };

    _this.setAmountField = function (name, value) {
      var amt = Object(utility["e" /* numberWithCommas */])(value);
      _this.state.inputValue && _this.props.updateAmount(-Number(Object(utility["f" /* numberWithoutCommas */])(_this.state.inputValue)));
      _this.setState({ inputSelectedValue: name + " - \u20B9" + value, inputValue: amt });
      _this.updateValue(amt, name);
    };

    _this.updateSelected = function (name, value) {
      _this.setAmountField(name, value);
      _this.toggleDropDown();
    };

    _this.getOption = function (options) {
      return options.map(function (_ref) {
        var name = _ref.name,
            value = _ref.value;
        return Object(preact_min["h"])(
          "li",
          {
            className: dropdown_amount_style_default.a["select-item"] + " " + dropdown_amount_style_default.a["list-option"],
            onClick: function onClick() {
              _this.updateSelected(name, value);
            }
          },
          Object(preact_min["h"])(
            "span",
            { className: "" + dropdown_amount_style_default.a["select-txt"] },
            "" + name + (value ? " - ₹" : "") + value
          )
        );
      });
    };

    _this.state = {
      isError: false,
      errorName: "Value is required",
      inputValue: "",
      showDropDown: false,
      inputSelectedValue: ""
    };
    _this.node = "";
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
    _this.handleDropdownClick = _this.handleDropdownClick.bind(_this);
    return _this;
  }

  DropdownAmountInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  };

  DropdownAmountInput.prototype.addCloseEvent = function addCloseEvent() {
    document.addEventListener("click", this.handleOutsideClick, false);
  };

  DropdownAmountInput.prototype.removeCloseEvent = function removeCloseEvent() {
    document.removeEventListener("click", this.handleOutsideClick, false);
  };

  DropdownAmountInput.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextSate) {
    if (nextProps.inputValue == this.props.inputValue && nextProps.isError == this.props.isError && nextProps.errorName == this.props.errorName && this.state.showDropDown == nextSate.showDropDown) {
      return false;
    }
  };

  DropdownAmountInput.prototype.handleOutsideClick = function handleOutsideClick(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.removeCloseEvent();
    this.handleDropdownClick(e, true);
  };

  DropdownAmountInput.prototype.handleDropdownClick = function handleDropdownClick(e) {
    var clickOutside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (clickOutside) {
      this.setState({ showDropDown: false });
      return;
    }
    if (!this.state.showDropDown) {
      this.addCloseEvent();
    } else {
      this.removeCloseEvent();
    }
    if (!clickOutside) {
      this.clearErrors();
    }
    this.toggleDropDown();
  };

  DropdownAmountInput.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick, false);
  };

  DropdownAmountInput.prototype.render = function render(_ref2, _ref3) {
    var _this2 = this;

    var name = _ref2.name,
        constraints = _ref2.constraints,
        placeholder = _ref2.placeholder,
        subText = _ref2.subText;
    var inputSelectedValue = _ref3.inputSelectedValue,
        inputValue = _ref3.inputValue;

    return Object(preact_min["h"])(
      "div",
      { className: "pos-r mt10" },
      Object(preact_min["h"])(
        "div",
        {
          ref: function ref(node) {
            _this2.node = node;
          }
        },
        Object(preact_min["h"])(
          "div",
          { className: "" + dropdown_amount_style_default.a["select-head"], onClick: this.handleDropdownClick },
          placeholder && !this.state.inputValue && Object(preact_min["h"])(
            "span",
            { className: "" + dropdown_amount_style_default.a["select-para"] },
            placeholder
          ),
          !Object(util["isNullOrUndefined"])(inputValue) && inputValue.length > 0 && Object(preact_min["h"])(
            "span",
            { className: "" + dropdown_amount_style_default.a["value-added"] },
            inputSelectedValue
          ),
          Object(preact_min["h"])(
            "span",
            { className: "" + dropdown_amount_style_default.a["drop-link"] },
            Object(preact_min["h"])("img", { src: common["a" /* default */].getStaticPath() + "/assets/ic-chevron-down.svg" })
          )
        ),
        Object(preact_min["h"])(
          "div",
          { className: dropdown_amount_style_default.a["select-dropdown"] + " " + (this.state.showDropDown ? dropdown_amount_style_default.a.visible : "") },
          Object(preact_min["h"])(
            "ul",
            { className: "" + dropdown_amount_style_default.a["select-list"] },
            this.getOption(constraints.allowedValues)
          )
        )
      ),
      subText && Object(preact_min["h"])(
        "p",
        { className: "input-info" },
        subText
      ),
      this.state.isError && Object(preact_min["h"])(
        "span",
        { className: "error " + (subText ? "sub-txt-err" : ""), "data-error-for": name },
        this.state.errorName
      )
    );
  };

  return DropdownAmountInput;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./form/components/footerlink/style.css
var footerlink_style = __webpack_require__("i7CM");
var footerlink_style_default = /*#__PURE__*/__webpack_require__.n(footerlink_style);

// CONCATENATED MODULE: ./form/components/footerlink/index.js


function footerlink__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function footerlink__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function footerlink__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var footerlink_FooterLink = function (_Component) {
  footerlink__inherits(FooterLink, _Component);

  function FooterLink() {
    footerlink__classCallCheck(this, FooterLink);

    return footerlink__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  FooterLink.prototype.render = function render() {
    return Object(preact_min["h"])(
      "div",
      { className: footerlink_style_default.a["footer-inner"] },
      this.props.triggerJSCheckout ? Object(preact_min["h"])("img", {
        className: "float-l secure-img",
        src: common["a" /* default */].getStaticPath() + "/assets/secure.png",
        height: "20",
        alt: "business logo"
      }) : Object(preact_min["h"])("img", {
        className: "float-l ptm-bsng-log",
        src: common["a" /* default */].getStaticPath() + "/assets/logo-business.png",
        height: "20",
        alt: "business logo"
      }),
      this.props.triggerJSCheckout ? Object(preact_min["h"])(
        "span",
        { className: footerlink_style_default.a["footer-txt"] },
        "100% Secure Payments ",
        Object(preact_min["h"])(
          "span",
          { style: { fontWeight: "bold" } },
          "Powered by "
        ),
        Object(preact_min["h"])(
          "a",
          {
            className: footerlink_style_default.a["business-link"],
            rel: "noopener noreferrer",
            href: constants["a" /* default */].PAYTM_BUSINESS_LINK_URL,
            target: "_blank",
            onClick: function onClick() {
              Object(logger["b" /* logEvent */])({ eventType: "paytm_business_link" });
            }
          },
          Object(preact_min["h"])("img", { height: "11", className: footerlink_style_default.a["ptm-logo"], src: common["a" /* default */].getStaticPath() + "/assets/paytm-logo-blue.png", alt: "Paytm" })
        )
      ) : Object(preact_min["h"])(
        "span",
        { className: footerlink_style_default.a["footer-txt"] },
        Object(i18n["b" /* locale */])("footer.visit.payment.link"),
        " ",
        Object(preact_min["h"])(
          "a",
          {
            className: footerlink_style_default.a["business-link"],
            rel: "noopener noreferrer",
            href: constants["a" /* default */].PAYTM_BUSINESS_LINK_URL,
            target: "_blank",
            onClick: function onClick() {
              Object(logger["b" /* logEvent */])({ eventType: "paytm_business_link" });
            }
          },
          "business.paytm.com/payment-link"
        )
      ),
      Object(preact_min["h"])("img", { className: "float-r hide-m", src: common["a" /* default */].getStaticPath() + "/assets/pro.png", height: "20", alt: "logos" })
    );
  };

  return FooterLink;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./form/components/inputs/user-amount/style.css
var user_amount_style = __webpack_require__("kSUl");
var user_amount_style_default = /*#__PURE__*/__webpack_require__.n(user_amount_style);

// CONCATENATED MODULE: ./form/components/inputs/user-amount/index.js


function user_amount__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function user_amount__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function user_amount__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var user_amount_AmountInput = function (_Component) {
  user_amount__inherits(AmountInput, _Component);

  function AmountInput(props) {
    user_amount__classCallCheck(this, AmountInput);

    var _this = user_amount__possibleConstructorReturn(this, _Component.call(this, props));

    _this.validateNumberInput = function (event) {
      if (!Object(utility["d" /* isNumber */])(event)) {
        Object(common["b" /* preventDefault */])(event);
      }
    };

    _this.updateValue = function (amt) {
      _this.props.updateFormValue(_this.props.index, Object(utility["f" /* numberWithoutCommas */])(amt));
    };

    _this.clearErrors = function () {
      if (_this.state.isError && !Object(util["isNullOrUndefined"])(_this.props.index)) {
        _this.props.clearErrorData(_this.props.index);
      }
      Object(logger["b" /* logEvent */])({ eventType: "clicked_form_field", eventValue: "amount form field", fieldName: _this.props.name });
    };

    _this.validateWebAmount = function (event) {
      if (Object(common["d" /* validateAmountWeb */])(event)) {} else {
        return Object(common["b" /* preventDefault */])(event);
      }
    };

    _this.setAmountField = function (event) {
      if (event && event.target) {
        var showRs = Object(common["c" /* showRupee */])(event, false);
        var amt = Object(utility["e" /* numberWithCommas */])(event.target.value);
        if (amt === "") {
          showRs = Object(common["c" /* showRupee */])(event, false);
        }
        _this.setState({ showRupeeInAmount: showRs, inputValue: amt });
        _this.updateValue(amt);
      }
    };

    _this.pasteNumber = function (event) {
      setTimeout(function () {
        if (event && event.target) {
          var number = event.target.value;
          if (Object(utility["d" /* isNumber */])(number)) {
            _this.setAmountField(event);
          } else {
            event.target.value = "";
          }
        }
      }, 0);
    };

    _this.state = { isError: false, errorName: "", inputValue: "", showRupeeInAmount: false };
    return _this;
  }

  AmountInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  };

  AmountInput.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (nextProps.inputValue == this.props.inputValue && nextProps.isError == this.props.isError && nextProps.errorName == this.props.errorName) {
      return false;
    }
  };

  // onPaste={this.pasteNumber}
  AmountInput.prototype.render = function render(_ref) {
    var name = _ref.name,
        constraints = _ref.constraints,
        placeholder = _ref.placeholder,
        subText = _ref.subText;

    var maxLength = constraints.maxLength ? constraints.maxLength : "";
    return Object(preact_min["h"])(
      "div",
      { className: user_amount_style_default.a["pos-r"] },
      this.state.showRupeeInAmount && Object(preact_min["h"])(
        "span",
        { id: "rupee", className: "" + user_amount_style_default.a["rupee-sign"] },
        "\u20B9"
      ),
      Object(preact_min["h"])("input", {
        name: name,
        type: "text",
        inputmode: "numeric",
        value: this.state.inputValue,
        placeholder: placeholder,
        maxlength: maxLength,
        onKeyDown: this.validateWebAmount,
        onKeyUp: this.setAmountField,
        onFocus: this.clearErrors,
        className: this.state.showRupeeInAmount ? user_amount_style_default.a["has-val"] : "",
        onPaste: this.pasteNumber,
        autocomplete: "off"
      }),
      subText && Object(preact_min["h"])(
        "p",
        { className: "input-info" },
        subText
      ),
      this.state.isError && Object(preact_min["h"])(
        "span",
        { className: "error " + (subText ? "sub-txt-err" : ""), "data-error-for": name },
        this.state.errorName
      )
    );
  };

  return AmountInput;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./form/components/inputs/mobilenumber/index.js


function mobilenumber__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function mobilenumber__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function mobilenumber__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var mobilenumber_MobileNumberInput = function (_Component) {
  mobilenumber__inherits(MobileNumberInput, _Component);

  function MobileNumberInput(props) {
    mobilenumber__classCallCheck(this, MobileNumberInput);

    var _this = mobilenumber__possibleConstructorReturn(this, _Component.call(this, props));

    _this.validateNumberInput = function (event) {
      if (!Object(utility["d" /* isNumber */])(event)) {
        Object(common["b" /* preventDefault */])(event);
      }
    };

    _this.updateValue = function (event) {
      if (event && event.target) {
        _this.setState(function () {
          return { inputValue: event.target.value.trim() };
        });
        _this.props.updateFormValue(_this.props.index, _this.state.inputValue);
      }
    };

    _this.clearErrors = function () {
      if (_this.state.isError && !Object(util["isNullOrUndefined"])(_this.props.index)) {
        _this.props.clearErrorData(_this.props.index);
      }
      Object(logger["b" /* logEvent */])({ eventType: "clicked_form_field", eventValue: "mobile number form field", fieldName: _this.props.name });
    };

    _this.pasteNumber = function (event) {
      setTimeout(function () {
        if (event && event.target) {
          var number = event.target.value;
          if (Object(utility["d" /* isNumber */])(number)) {
            _this.setState(function () {
              return { inputValue: number.trim() };
            });
            _this.props.updateFormValue(_this.props.index, _this.state.inputValue);
          } else {
            event.target.value = "";
          }
        }
      }, 0);
    };

    _this.state = { isError: false, errorName: "", inputValue: "" };
    return _this;
  }

  MobileNumberInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  };

  MobileNumberInput.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (nextProps.inputValue == this.props.inputValue && nextProps.isError == this.props.isError && nextProps.errorName == this.props.errorName) {
      return false;
    }
  };

  MobileNumberInput.prototype.render = function render(_ref) {
    var name = _ref.name,
        constraints = _ref.constraints,
        placeholder = _ref.placeholder,
        subText = _ref.subText;

    var maxLength = constraints.maxLength ? constraints.maxLength : "";
    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])("input", {
        name: name,
        type: "text",
        value: this.state.inputValue,
        placeholder: placeholder,
        maxlength: maxLength,
        onKeyDown: this.validateNumberInput,
        onChange: this.updateValue,
        onFocus: this.clearErrors,
        onPaste: this.pasteNumber,
        autocomplete: "off"
      }),
      subText && Object(preact_min["h"])(
        "p",
        { className: "input-info" },
        subText
      ),
      this.state.isError && Object(preact_min["h"])(
        "span",
        { className: "error " + (subText ? "sub-txt-err" : ""), "data-error-for": name },
        this.state.errorName
      )
    );
  };

  return MobileNumberInput;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./form/components/inputs/merchant-amount/style.css
var merchant_amount_style = __webpack_require__("bsih");
var merchant_amount_style_default = /*#__PURE__*/__webpack_require__.n(merchant_amount_style);

// CONCATENATED MODULE: ./form/components/inputs/merchant-amount/index.js


function merchant_amount__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function merchant_amount__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function merchant_amount__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var merchant_amount_MerchantAmountInput = function (_Component) {
  merchant_amount__inherits(MerchantAmountInput, _Component);

  function MerchantAmountInput(props) {
    merchant_amount__classCallCheck(this, MerchantAmountInput);

    var _this = merchant_amount__possibleConstructorReturn(this, _Component.call(this, props));

    _this.validateNumberInput = function (event) {
      if (!Object(utility["d" /* isNumber */])(event)) {
        Object(common["b" /* preventDefault */])(event);
      }
    };

    _this.updateValue = function (amt) {
      _this.props.updateFormValue(_this.props.index, Object(utility["f" /* numberWithoutCommas */])(amt));
      _this.props.updateAmount(Number(Object(utility["f" /* numberWithoutCommas */])(amt)));
    };

    _this.clearErrors = function () {
      if (_this.state.isError && !Object(util["isNullOrUndefined"])(_this.props.index)) {
        _this.props.clearErrorData(_this.props.index);
      }
      Object(logger["b" /* logEvent */])({ eventType: "clicked_form_field", eventValue: "amount form field", fieldName: _this.props.name });
    };

    _this.validateWebAmount = function (event) {
      if (!Object(common["d" /* validateAmountWeb */])(event)) {
        return Object(common["b" /* preventDefault */])(event);
      }
    };

    _this.setAmountField = function (event) {
      if (event && event.target) {
        var showRs = Object(common["c" /* showRupee */])(event, false);
        var amt = Object(utility["e" /* numberWithCommas */])(event.target.value);
        if (amt === "") {
          showRs = Object(common["c" /* showRupee */])(event, false);
        }
        // Minus prevoius value from total amount
        _this.state.inputValue && _this.props.updateAmount(-Number(Object(utility["f" /* numberWithoutCommas */])(_this.state.inputValue)));
        _this.setState({ showRupeeInAmount: showRs, inputValue: amt });
        _this.updateValue(amt);
      }
    };

    _this.pasteNumber = function (event) {
      setTimeout(function () {
        if (event && event.target) {
          var number = event.target.value;
          if (Object(utility["d" /* isNumber */])(number)) {
            _this.setAmountField(event);
          } else {
            event.target.value = "";
          }
        }
      }, 0);
    };

    _this.toogleAmountCheck = function () {
      if (_this.state.isAmountChecked) {
        _this.props.updateAmount(-Number(Object(utility["f" /* numberWithoutCommas */])(_this.state.inputValue)));
        _this.updateValue("");
      } else {
        _this.updateValue(_this.state.inputValue);
      }
      _this.setState(function (prevState) {
        return { isAmountChecked: !prevState.isAmountChecked };
      });
    };

    _this.toggleAmountInput = function (val) {
      _this.state.showRupeeInAmount && _this.setState({ showAmountInput: val });
      val && setTimeout(function () {
        if (_this.amtInput) {
          _this.amtInput.focus();
        }
      }, 0);
    };

    _this.state = {
      inputValue: props.constraints.value ? props.constraints.value : "",
      isAmountChecked: false,
      showAmountInput: true
    };
    _this.isFixedAmount = !!props.constraints.value;
    _this.showAmountCheck = !props.constraints[constants["a" /* default */].MANDATORY_VALIDATION];
    _this.amtInput = "";
    return _this;
  }

  MerchantAmountInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      var error = nextProps.errorName;
      var fieldName = this.props.name;
      if (error && error.indexOf(fieldName) === 0 && error.toLowerCase().indexOf(fieldName.toLowerCase() + " amount") !== 0) {
        error = error.replace(fieldName, "Amount");
      }
      this.setState({ isError: nextProps.isError, errorName: error });
    }
  };

  MerchantAmountInput.prototype.componentDidMount = function componentDidMount() {
    if (!this.showAmountCheck && this.isFixedAmount) {
      this.updateValue(this.state.inputValue);
    }
  };

  MerchantAmountInput.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var name = _ref.name,
        constraints = _ref.constraints,
        placeholder = _ref.placeholder,
        subText = _ref.subText;
    var inputValue = _ref2.inputValue,
        isAmountChecked = _ref2.isAmountChecked,
        showAmountInput = _ref2.showAmountInput,
        showRupeeInAmount = _ref2.showRupeeInAmount,
        errorName = _ref2.errorName;

    var maxLength = constraints.maxLength ? constraints.maxLength : "";
    return this.isFixedAmount ? Object(preact_min["h"])(
      "div",
      { className: "" + merchant_amount_style_default.a["pos-r"] },
      Object(preact_min["h"])(
        "div",
        { className: "" + merchant_amount_style_default.a.clear },
        Object(preact_min["h"])(
          "div",
          { className: merchant_amount_style_default.a["amt-label"] + " " + merchant_amount_style_default.a.ibl },
          placeholder
        ),
        Object(preact_min["h"])(
          "div",
          { className: merchant_amount_style_default.a["amt-label"] + " " + merchant_amount_style_default.a.ibl + " " + merchant_amount_style_default.a.tr + " " + merchant_amount_style_default.a.cb },
          Object(preact_min["h"])(
            "span",
            { className: "" + merchant_amount_style_default.a["rupee-sign"] },
            "\u20B9"
          ),
          Object(utility["e" /* numberWithCommas */])(inputValue),
          this.showAmountCheck && Object(preact_min["h"])(
            "div",
            { className: merchant_amount_style_default.a["pos-r"] + " " + merchant_amount_style_default.a.ib + " " + merchant_amount_style_default.a["c-mark-box"] },
            Object(preact_min["h"])(
              "div",
              { className: merchant_amount_style_default.a["custom-check"] + " " + merchant_amount_style_default.a.ib },
              Object(preact_min["h"])("input", { type: "checkbox", checked: isAmountChecked, onClick: this.toogleAmountCheck }),
              Object(preact_min["h"])("span", { className: merchant_amount_style_default.a["c-mark"] + " " + merchant_amount_style_default.a.ib, "area-hidden": "true" })
            )
          )
        )
      ),
      subText && Object(preact_min["h"])(
        "p",
        { className: "input-info " + merchant_amount_style_default.a.info },
        subText
      )
    ) : Object(preact_min["h"])(
      "div",
      { className: "" + merchant_amount_style_default.a["pos-r"] },
      Object(preact_min["h"])(
        "div",
        { className: "" + merchant_amount_style_default.a.clear },
        Object(preact_min["h"])(
          "div",
          { className: merchant_amount_style_default.a["amt-label"] + " " + merchant_amount_style_default.a.ibl },
          placeholder
        ),
        Object(preact_min["h"])(
          "div",
          { className: merchant_amount_style_default.a["amt-label"] + " " + merchant_amount_style_default.a.ibl + " " + merchant_amount_style_default.a.tr + "  " + merchant_amount_style_default.a.cb },
          showRupeeInAmount && Object(preact_min["h"])(
            "span",
            { id: "rupee", className: "" + merchant_amount_style_default.a["rupee-sign"] },
            "\u20B9"
          ),
          showAmountInput && Object(preact_min["h"])("input", {
            ref: function ref(inp) {
              return _this2.amtInput = inp;
            },
            name: name,
            type: "text",
            inputmode: "numeric",
            value: inputValue,
            placeholder: "Enter amount",
            maxlength: maxLength,
            onKeyDown: this.validateWebAmount,
            onKeyUp: this.setAmountField,
            onFocus: this.clearErrors,
            onBlur: function onBlur() {
              return _this2.toggleAmountInput(false);
            },
            className: merchant_amount_style_default.a["amount-inp"] + " " + (showRupeeInAmount ? merchant_amount_style_default.a["has-val"] : ""),
            onPaste: this.pasteNumber,
            autocomplete: "on"
          }),
          !showAmountInput && Object(preact_min["h"])(
            "span",
            { className: "" + merchant_amount_style_default.a["fix-amt"], onClick: function onClick() {
                return _this2.toggleAmountInput(true);
              } },
            inputValue
          )
        )
      ),
      subText && Object(preact_min["h"])(
        "p",
        { className: "input-info " + merchant_amount_style_default.a.info },
        subText
      ),
      this.state.isError && Object(preact_min["h"])(
        "span",
        { className: "error " + (subText ? "sub-txt-err" : ""), "data-error-for": name },
        errorName
      )
    );
  };

  return MerchantAmountInput;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./form/components/async/spinner-amount/index.js

		

		function spinner_amount_load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function(require) {
				cb(__webpack_require__("cDAC"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var spinner_amount = (async_default()(spinner_amount_load));
	
// EXTERNAL MODULE: ./form/components/inputs/quantity-amount/style.css
var quantity_amount_style = __webpack_require__("jUR6");
var quantity_amount_style_default = /*#__PURE__*/__webpack_require__.n(quantity_amount_style);

// CONCATENATED MODULE: ./form/components/inputs/quantity-amount/index.js


function quantity_amount__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function quantity_amount__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function quantity_amount__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var quantity_amount_QuantityAmount = function (_Component) {
  quantity_amount__inherits(QuantityAmount, _Component);

  function QuantityAmount(props) {
    quantity_amount__classCallCheck(this, QuantityAmount);

    var _this = quantity_amount__possibleConstructorReturn(this, _Component.call(this, props));

    _this.validateNumberInput = function (event) {
      if (!Object(utility["d" /* isNumber */])(event)) {
        Object(common["b" /* preventDefault */])(event);
      }
    };

    _this.updateValue = function (quantity) {
      _this.props.updateFormValue(_this.props.index, quantity);
      _this.props.updateAmount(_this.perUnitValue * quantity);
    };

    _this.clearErrors = function () {
      if (_this.state.isError && !Object(util["isNullOrUndefined"])(_this.props.index)) {
        _this.props.clearErrorData(_this.props.index);
      }
      Object(logger["b" /* logEvent */])({ eventType: "clicked_form_field", eventValue: "amount form field", fieldName: _this.props.name });
    };

    _this.hideButton = function () {
      _this.setState({ showAddButon: false });
      _this.clearErrors();
      _this.setQuantity(_this.counterStartValue);
      Object(logger["b" /* logEvent */])({ eventType: "clicked_add_button", eventValue: "amount add button", fieldName: _this.props.name });
    };

    _this.showAddButton = function () {
      _this.setState({ showAddButon: true });
      _this.clearErrors();
      _this.setQuantity("");
      Object(logger["b" /* logEvent */])({ eventType: "clicked_remove_button", eventValue: "amount remove button", fieldName: _this.props.name });
    };

    _this.setQuantity = function (count) {
      _this.props.updateAmount(-(_this.perUnitValue * _this.state.inputValue));
      _this.setState({ inputValue: count });
      _this.updateValue(_this.state.inputValue);
      _this.state.isError ? _this.clearErrors() : "";
    };

    _this.state = { isError: false, errorName: "", showAddButon: true, inputValue: "" };
    _this.perUnitValue = props.constraints.value ? Number(props.constraints.value) : 0;
    _this.startValue = props.constraints.minValue ? props.constraints.minValue : 1;
    // Start counter value always from 1
    _this.counterStartValue = props.constraints.minValue && props.constraints.minValue !== "0" ? props.constraints.minValue : 1;
    return _this;
  }

  QuantityAmount.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  };

  QuantityAmount.prototype.render = function render(_ref, _ref2) {
    var name = _ref.name,
        constraints = _ref.constraints,
        placeholder = _ref.placeholder,
        subText = _ref.subText;
    var showAddButon = _ref2.showAddButon;

    return Object(preact_min["h"])(
      "div",
      { className: "" + quantity_amount_style_default.a["pos-r"] },
      Object(preact_min["h"])(
        "div",
        { className: "" + quantity_amount_style_default.a.clear },
        Object(preact_min["h"])(
          "div",
          { className: quantity_amount_style_default.a["amt-label"] + " " + quantity_amount_style_default.a.ibl },
          placeholder
        ),
        Object(preact_min["h"])(
          "div",
          { className: quantity_amount_style_default.a.quantity + " " + quantity_amount_style_default.a.ibl + " " + quantity_amount_style_default.a.tr },
          Object(preact_min["h"])(
            "span",
            { className: "" + quantity_amount_style_default.a["rupee-sign"] },
            "\u20B9"
          ),
          Object(utility["e" /* numberWithCommas */])(this.perUnitValue),
          " ",
          Object(preact_min["h"])(
            "span",
            { className: quantity_amount_style_default.a.mult },
            "\xD7"
          ),
          showAddButon && Object(preact_min["h"])(
            "span",
            { className: "" + quantity_amount_style_default.a["link-btn"], onClick: this.hideButton },
            Object(i18n["b" /* locale */])("button.add")
          ),
          !showAddButon && Object(preact_min["h"])(
            "span",
            null,
            Object(preact_min["h"])(spinner_amount, {
              constraints: constraints,
              setQuantity: this.setQuantity,
              counterStartValue: this.counterStartValue
            })
          ),
          !showAddButon && Object(preact_min["h"])(
            "span",
            { className: "" + quantity_amount_style_default.a["link-btn"], onClick: this.showAddButton },
            Object(i18n["b" /* locale */])("button.remove")
          )
        )
      ),
      subText && Object(preact_min["h"])(
        "p",
        { className: "input-info " + quantity_amount_style_default.a.info },
        subText
      ),
      this.state.isError && Object(preact_min["h"])(
        "span",
        { className: "error " + (subText ? "sub-txt-err" : ""), "data-error-for": name },
        this.state.errorName
      )
    );
  };

  return QuantityAmount;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./form/components/inputs/partial-amount/style.css
var partial_amount_style = __webpack_require__("FHM5");
var partial_amount_style_default = /*#__PURE__*/__webpack_require__.n(partial_amount_style);

// CONCATENATED MODULE: ./form/components/inputs/partial-amount/index.js


function partial_amount__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function partial_amount__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function partial_amount__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var partial_amount__ref3 = Object(preact_min["h"])("span", { className: "c-mark", "area-hidden": "true" });

var _ref4 = Object(preact_min["h"])("span", { className: "c-mark", "area-hidden": "true" });

var partial_amount_PartialAmountInput = function (_Component) {
  partial_amount__inherits(PartialAmountInput, _Component);

  function PartialAmountInput(props) {
    partial_amount__classCallCheck(this, PartialAmountInput);

    var _this = partial_amount__possibleConstructorReturn(this, _Component.call(this, props));

    _this.validateNumberInput = function (event) {
      if (!Object(utility["d" /* isNumber */])(event)) {
        Object(common["b" /* preventDefault */])(event);
      }
    };

    _this.updateValue = function (amt) {
      _this.props.updateFormValue(_this.props.index, Object(utility["f" /* numberWithoutCommas */])(amt));
      _this.props.updateAmount(Number(Object(utility["f" /* numberWithoutCommas */])(amt)));
    };

    _this.clearErrors = function () {
      if (_this.state.isError && !Object(util["isNullOrUndefined"])(_this.props.index)) {
        _this.props.clearErrorData(_this.props.index);
      }
      Object(logger["b" /* logEvent */])({ eventType: "clicked_form_field", eventValue: "amount form field", fieldName: _this.props.name });
    };

    _this.validateWebAmount = function (event) {
      if (!Object(common["d" /* validateAmountWeb */])(event)) {
        return Object(common["b" /* preventDefault */])(event);
      }
    };

    _this.setAmountField = function (event) {
      if (event && event.target) {
        var showRs = Object(common["c" /* showRupee */])(event, false);
        var amt = Object(utility["e" /* numberWithCommas */])(event.target.value);
        if (amt === "") {
          showRs = Object(common["c" /* showRupee */])(event, false);
        }
        _this.setState({ showRupeeInAmount: showRs, inputValue: amt });
        _this.updateValue(amt);
      }
    };

    _this.pasteNumber = function (event) {
      setTimeout(function () {
        if (event && event.target) {
          var number = event.target.value;
          if (Object(utility["d" /* isNumber */])(number)) {
            _this.setAmountField(event);
          } else {
            event.target.value = "";
          }
        }
      }, 0);
    };

    _this.selectMode = function (val) {
      if (val === "full") {
        _this.setState({
          showAmountInput: false,
          inputValue: _this.maxValue,
          isFullAmount: true,
          isPartialAmount: false,
          showRupeeInAmount: false
        });
        _this.updateValue(_this.maxValue);
      } else {
        _this.setState({ showAmountInput: true, inputValue: "", isFullAmount: false, isPartialAmount: true });
        _this.amtInput && _this.amtInput.focus();
        _this.updateValue("");
      }
    };

    _this.maxValue = Object(utility["c" /* getKey */])(props, "partialAmountData.payableAmount", "");
    _this.state = { inputValue: _this.maxValue, showAmountInput: false, isFullAmount: true, isPartialAmount: false };
    _this.amtInput = "";
    _this.updateValue(_this.maxValue);
    return _this;
  }

  PartialAmountInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      var error = nextProps.errorName;
      var fieldName = this.props.name;
      if (Number(Object(utility["f" /* numberWithoutCommas */])(this.state.inputValue)) > Number(Object(utility["f" /* numberWithoutCommas */])(this.maxValue))) {
        error = Object(i18n["b" /* locale */])("error.partial.amount.max");
      } else if (error && error.indexOf(fieldName) === 0 && error.toLowerCase().indexOf(fieldName.toLowerCase() + " amount") !== 0) {
        error = error.replace(fieldName, "Amount");
      }
      this.setState({ isError: nextProps.isError, errorName: error });
    }
  };

  PartialAmountInput.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var name = _ref.name,
        constraints = _ref.constraints,
        placeholder = _ref.placeholder,
        subText = _ref.subText;
    var inputValue = _ref2.inputValue,
        showAmountInput = _ref2.showAmountInput,
        showRupeeInAmount = _ref2.showRupeeInAmount,
        isPartialAmount = _ref2.isPartialAmount,
        isFullAmount = _ref2.isFullAmount,
        isError = _ref2.isError,
        errorName = _ref2.errorName;

    var maxLength = constraints.maxLength ? constraints.maxLength : "";
    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        "p",
        { className: partial_amount_style_default.a["select-head"] },
        Object(i18n["b" /* locale */])("form.select.pay")
      ),
      Object(preact_min["h"])(
        "span",
        { className: partial_amount_style_default.a["radio-inp"], onClick: function onClick() {
            return _this2.selectMode("full");
          } },
        Object(preact_min["h"])(
          "label",
          { className: "custom-radio" },
          Object(preact_min["h"])("input", {
            className: partial_amount_style_default.a.radio,
            type: "radio",
            name: "authenticatemode",
            value: Object(i18n["b" /* locale */])("form.pay.full"),
            checked: isFullAmount
          }),
          partial_amount__ref3
        ),
        Object(preact_min["h"])(
          "span",
          { className: "pos-r bold" },
          Object(i18n["b" /* locale */])("form.pay.full")
        )
      ),
      Object(preact_min["h"])(
        "span",
        { className: partial_amount_style_default.a["radio-inp"], onClick: function onClick() {
            return _this2.selectMode("partial");
          } },
        Object(preact_min["h"])(
          "label",
          { className: "custom-radio" },
          Object(preact_min["h"])("input", {
            className: partial_amount_style_default.a.radio,
            type: "radio",
            name: "authenticatemode",
            value: Object(i18n["b" /* locale */])("form.pay.partial"),
            checked: isPartialAmount
          }),
          _ref4
        ),
        Object(preact_min["h"])(
          "span",
          { className: "pos-r bold" },
          Object(i18n["b" /* locale */])("form.pay.partial")
        )
      ),
      showAmountInput && Object(preact_min["h"])(
        "div",
        { className: partial_amount_style_default.a["pos-r"] + " " + partial_amount_style_default.a["amt-section"] },
        showRupeeInAmount && Object(preact_min["h"])(
          "span",
          { id: "rupee", className: "" + partial_amount_style_default.a["rupee-sign"] },
          "\u20B9"
        ),
        Object(preact_min["h"])("input", {
          ref: function ref(inp) {
            return _this2.amtInput = inp;
          },
          name: name,
          type: "text",
          inputmode: "numeric",
          value: inputValue,
          placeholder: placeholder,
          maxlength: maxLength,
          onKeyDown: this.validateWebAmount,
          onKeyUp: this.setAmountField,
          onFocus: this.clearErrors,
          className: showRupeeInAmount ? partial_amount_style_default.a["has-val"] : "",
          onPaste: this.pasteNumber,
          autocomplete: "off"
        }),
        subText && Object(preact_min["h"])(
          "p",
          { className: "input-info" },
          subText
        ),
        isError && Object(preact_min["h"])(
          "span",
          { className: "error " + (subText ? "sub-txt-err" : ""), "data-error-for": name },
          errorName
        )
      )
    );
  };

  return PartialAmountInput;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./utils/cache.js
var cache = __webpack_require__("dkoj");
var cache_default = /*#__PURE__*/__webpack_require__.n(cache);

// EXTERNAL MODULE: ./form/components/checkoutjs/style.css
var checkoutjs_style = __webpack_require__("d/uS");
var checkoutjs_style_default = /*#__PURE__*/__webpack_require__.n(checkoutjs_style);

// CONCATENATED MODULE: ./form/components/checkoutjs/index.js



var checkoutjs_CheckoutJS = function CheckoutJS(props) {
  return Object(preact_min["h"])(
    "div",
    { className: "" + checkoutjs_style_default.a["ptm-checkoutjs-container"], style: { display: props.show ? "block" : "none" } },
    Object(preact_min["h"])("div", { id: "paytm-checkoutjs", style: { overflow: 'hidden' }, className: "" + checkoutjs_style_default.a["ptm-checkoutjs-lg-wrapper"] }),
    Object(preact_min["h"])(
      "div",
      { className: "" + checkoutjs_style_default.a["ptm-checkoutjs-footer"] },
      Object(preact_min["h"])(
        "div",
        { className: "" + checkoutjs_style_default.a["ptm-checkoutjs-footer-container"] },
        Object(preact_min["h"])(
          "div",
          { className: "" + checkoutjs_style_default.a["ptm-checkoutjs-f-i-container"] },
          props.children
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: "" + checkoutjs_style_default.a["ptm-checkoutjs-b-f-container"] },
        Object(preact_min["h"])("div", { className: "" + checkoutjs_style_default.a["b1-style"] }),
        Object(preact_min["h"])("div", { className: "" + checkoutjs_style_default.a["b2-style"] })
      )
    )
  );
};
/* harmony default export */ var checkoutjs = (checkoutjs_CheckoutJS);
// EXTERNAL MODULE: ../mock-app-data/form/date-widget/index.js
var date_widget = __webpack_require__("K/zd");
var date_widget_default = /*#__PURE__*/__webpack_require__.n(date_widget);

// EXTERNAL MODULE: ../mock-app-data/form/amount-fields/index.js
var amount_fields = __webpack_require__("7YXT");
var amount_fields_default = /*#__PURE__*/__webpack_require__.n(amount_fields);

// CONCATENATED MODULE: ./form/components/app.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var app_PaymentForm = function (_Component) {
  app__inherits(PaymentForm, _Component);

  function PaymentForm(props) {
    var _this$fieldTypeMap;

    app__classCallCheck(this, PaymentForm);

    var _this = app__possibleConstructorReturn(this, _Component.call(this, props));

    _this.fieldTypeMap = (_this$fieldTypeMap = {}, _this$fieldTypeMap[constants["a" /* default */].CUSTOM_TEXT] = text_TextInput, _this$fieldTypeMap[constants["a" /* default */].CUSTOM_NUMBER] = number_NumberInput, _this$fieldTypeMap[constants["a" /* default */].CUSTOM_DROPDOWN] = list_ListInput, _this$fieldTypeMap[constants["a" /* default */].CUSTOM_DATE] = date_DateInput, _this$fieldTypeMap[constants["a" /* default */].CUSTOM_AMOUNT] = user_amount_AmountInput, _this$fieldTypeMap[constants["a" /* default */].CUSTOM_MOBILE_NUMBER] = mobilenumber_MobileNumberInput, _this$fieldTypeMap[constants["a" /* default */].CUSTOM_AMOUNT_MERCHANT] = merchant_amount_MerchantAmountInput, _this$fieldTypeMap[constants["a" /* default */].CUSTOM_AMOUNT_QUANTATIVE] = quantity_amount_QuantityAmount, _this$fieldTypeMap[constants["a" /* default */].CUSTOM_AMOUNT_PARTIAL] = partial_amount_PartialAmountInput, _this$fieldTypeMap[constants["a" /* default */].CUSTOM_AMOUNT_DROPDOWN] = dropdown_amount_DropdownAmountInput, _this$fieldTypeMap);

    _this.getFormFields = function (inputValue, isError, errorName, type, name, constraints, placeholder, subText, index) {
      var size = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 100;
      var updateFormValue = arguments[10];
      var clearErrorData = arguments[11];
      var updateAmount = arguments[12];

      var InputField = _this.fieldTypeMap[type];
      return InputField ? Object(preact_min["h"])(
        "div",
        { className: "custom-length", style: "width:" + size + "%" },
        Object(preact_min["h"])(
          "div",
          { className: "spacer" },
          Object(preact_min["h"])(InputField, {
            inputValue: inputValue,
            isError: isError,
            errorName: errorName,
            placeholder: placeholder,
            name: name,
            constraints: constraints,
            subText: subText,
            index: index,
            updateFormValue: updateFormValue,
            clearErrorData: clearErrorData,
            updateAmount: updateAmount,
            partialAmountData: _this.partialAmountData
          })
        )
      ) : "";
    };

    _this.setInitialTotalAmount = function () {
      var amt = 0;
      if (_this.partialAmountData && _this.partialAmountData.isPartialPayment) {
        amt = Number(Object(utility["f" /* numberWithoutCommas */])(_this.partialAmountData.payableAmount));
      } else {
        amt = _this.PaymentFormData.amount ? Number(Object(utility["f" /* numberWithoutCommas */])(_this.PaymentFormData.amount)) : 0;
      }
      _this.updateAmount(amt);
    };

    _this.updateAmount = function (amt) {
      if (!isNaN(amt)) {
        if (_this.partialAmountData && _this.partialAmountData.isPartialPayment) {
          _this.setState({ buttonAmount: amt, showPayLimitExceedError: false, payLimitExceedError: "" });
        } else if (!isNaN(parseFloat(_this.PaymentFormData.maxTxnAmount)) && _this.state.buttonAmount + amt > _this.PaymentFormData.maxTxnAmount) {
          _this.setState(function (prevState) {
            return {
              buttonAmount: prevState.buttonAmount + amt,
              showPayLimitExceedError: true,
              payLimitExceedError: "Total payment amount allowed limit exceeded. Please enter an amount less than or equal to \u20B9" + _this.PaymentFormData.maxTxnAmount
            };
          });
        } else {
          _this.setState(function (prevState) {
            return { buttonAmount: prevState.buttonAmount + amt, showPayLimitExceedError: false, payLimitExceedError: "" };
          });
        }
      }
    };

    _this.showCheckoutJS = function () {
      _this.setState({ isCheckoutjsEnabled: true });
    };

    _this.showLoader = function () {
      document.getElementById("ptm-loader").style.display = "block";
    };

    window.APP_DATA = window.APP_DATA ? window.APP_DATA : {};
    //window.APP_DATA = dropDownAmountField;
    _this.PaymentFormData = common["a" /* default */].parsePaymentFormData(window.APP_DATA);
    _this.PaymentFormData.fields = _this.PaymentFormData.fields ? _this.PaymentFormData.fields : [];
    _this.partialAmountData = _this.PaymentFormData.partialAmountData ? _this.PaymentFormData.partialAmountData : {};
    Object(cache["set"])(constants["a" /* default */].merchantName, _this.PaymentFormData.merchantName ? _this.PaymentFormData.merchantName : "");
    Object(logger["a" /* intializeLogger */])("paymentForm", {
      page: "paymentForm Page",
      linkId: _this.PaymentFormData.linkId ? _this.PaymentFormData.linkId : "",
      mid: _this.PaymentFormData.merchantId ? _this.PaymentFormData.merchantId : ""
    });
    Object(logger["b" /* logEvent */])({ eventType: "ON_PAGE_LOAD", eventValue: "App Data", appData: common["a" /* default */].parseFormAppData(window.APP_DATA) });
    _this.state = {
      buttonAmount: 0,
      isCheckoutjsEnabled: false,
      directCheckoutjsInvoke: false,
      checkoutjsLoader: false
    };
    _this.setInitialTotalAmount();

    var mid = Object(utility["c" /* getKey */])(_this.PaymentFormData, "merchantId", undefined);
    var host = common["a" /* default */].getAPIHOST();
    _this.checkoutScript = common["a" /* default */].setupCheckoutJS(host, mid);
    return _this;
  }

  PaymentForm.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var buttonAmount = _ref2.buttonAmount,
        isCheckoutjsEnabled = _ref2.isCheckoutjsEnabled,
        checkoutjsLoader = _ref2.checkoutjsLoader,
        showPayLimitExceedError = _ref2.showPayLimitExceedError,
        payLimitExceedError = _ref2.payLimitExceedError;

    _objectDestructuringEmpty(_ref);

    return Object(preact_min["h"])(
      "div",
      null,
      !isCheckoutjsEnabled ? Object(preact_min["h"])(
        "div",
        { className: "wrapper" },
        Object(preact_min["h"])(merchantinfo_MerchantInfo, {
          logoURL: this.PaymentFormData.imageName,
          name: this.PaymentFormData.merchantName,
          linkDescription: this.PaymentFormData.linkDescription,
          buttonAmount: buttonAmount,
          partialAmountData: this.partialAmountData
        }),
        Object(preact_min["h"])(paymentfields_PaymentFields, {
          getFormFields: this.getFormFields,
          templateInfo: this.PaymentFormData.templateInfo,
          linkId: this.PaymentFormData.linkId,
          fields: this.PaymentFormData.fields,
          amount: this.PaymentFormData.amount,
          showPayLimitExceedError: showPayLimitExceedError,
          payLimitExceedError: payLimitExceedError,
          buttonAmount: buttonAmount,
          updateAmount: this.updateAmount,
          partialAmountData: this.partialAmountData,
          triggerJSCheckout: this.PaymentFormData.triggerJSCheckout,
          showCheckoutJS: this.showCheckoutJS,
          toggleCheckoutjsLoader: function toggleCheckoutjsLoader() {
            return _this2.setState({ checkoutjsLoader: true });
          },
          mid: this.PaymentFormData.merchantId
        }),
        Object(preact_min["h"])(
          "div",
          { className: "footer" },
          Object(preact_min["h"])(footerlink_FooterLink, { linkType: this.PaymentFormData.linkType })
        )
      ) : null,
      isCheckoutjsEnabled && checkoutjsLoader && Object(preact_min["h"])(
        checkoutjs,
        { show: true },
        Object(preact_min["h"])(footerlink_FooterLink, { triggerJSCheckout: isCheckoutjsEnabled, linkType: this.PaymentFormData.linkType })
      )
    );
  };

  return PaymentForm;
}(preact_min["Component"]);


// CONCATENATED MODULE: ../locale/en.js
var _en$subscription;

var _en = {};

_en["link"] = {
    "enter.otp": "Enter OTP sent to mobile number",
    "otp.not.received": "OTP not received?  ",
    "blank.otp": "OTP can not be blank",
    "request.otp": "Request another OTP",
    "enter.mobile.number": "Enter your Mobile Number",
    "enter.amount": "Enter Amount",
    "enter.desc": "Description (Optional)",
    "desc.limit.error": "Description should be from 3 to 30 characters",
    "verify.mobile.number": "Verify Mobile Number",
    "will.send.otp": "We will send an OTP to this number",
    "change.number": "Change Number",
    "otp.sent": "OTP sent to mobile no.",
    "otp.verify": "Verify",
    "invalid.amount": "Invalid amount",
    "add.desc": "+ Add Description",
    "limit.reached.otp": "Oops ! You have reached OTP limit, please raise a query at paytm.com/care.",
    "amount.to.paid": "Amount to be paid",
    "pay": "PAY",
    "desc.max.min.error": "Description should be from 3 to 30 characters",
    "invalid.desc": "Description should not contain any special characters",
    "payment.details": "Payment Details",
    "total.amount": "Total Amount",
    "paid.till.date": "Paid Till Date",
    "balance.payable": "Balance Payable"
};

_en["form"] = {
    "required.error": "is required",
    "not.valid.value": "The entered value is not valid",
    "not.allowed.value": "The entered value is not allowed",
    "can.be.from": "can be from",
    "to": "to",
    "character": "characters",
    "can.be.between": "can be between",
    "and": "and",
    "fixed.length": "length must be",
    "payment.details": "Payment Details",
    "block.amt.heading": "Processing Payment",
    "block.amt.text": "The amount will be adjusted once payment is confirmed",
    "payment.history": "Payment History",
    "select.pay": "Choose amount to pay",
    "pay.full": "Pay full amount",
    "pay.partial": "Pay partial amount",
    "paid.on": "Paid on"
};
_en["invoice"] = {
    "expired.on": "Expired on",
    "already.paid": "Invoice already Paid",
    "billing.date": "Billing Date",
    "invoice.details": "INVOICE DETAILS",
    "invoice.id": "Invoice ID",
    "amount.to.paid": "AMOUNT TO BE PAID",
    "desc": "Description",
    "expiry.date": "Expiry Date",
    "customer.details": "CUSTOMER DETAILS",
    "name": "Name",
    "email": "Email",
    "phone.no": "Phone No.",
    "not.mentioned": "Not Mentioned",
    "billing.details": "BILLING DETAILS",
    "sno": "SNo.",
    "item.name": "Item Name",
    "item": 'Item',
    "qty": "Qty",
    "units": "Units",
    "price.per.unit": "Price per Unit",
    "tax": "Tax",
    "amount": "Amount",
    "total.amount": "Total Amount",
    "contact.merchant": "Contact Merchant",
    "download.invoice": "Download Invoice",
    "print.invoice": "Print Invoice",
    "ok.got.it": "OK Got it!"
};

_en["paymentPageInvoice"] = {
    "billing.date": "Billing Date",
    "invoice.details": "INVOICE DETAILS",
    "invoice.id": "Invoice ID",
    "amount.paid": "AMOUNT PAID",
    "desc": "Description",
    "expiry.date": "Expiry Date",
    "customer.details": "CUSTOMER DETAILS",
    "name": "Name",
    "email": "Email",
    "phone.no": "Phone No.",
    "not.mentioned": "Not Mentioned",
    "billing.details": "BILLING DETAILS",
    "sno": "SNo.",
    "item.name": "Item Name",
    "item": 'Item',
    "qty": "Qty",
    "units": "Units",
    "price.per.unit": "Price per Unit",
    "tax": "Tax",
    "amount": "Amount",
    "total.amount": "Total Amount: ",
    "gst.amount": "GST Amount: ",
    "contact.merchant": "Contact Merchant",
    "download.invoice": "Download Invoice",
    "print.invoice": "Print Invoice",
    "ok.got.it": "OK Got it!"
};

_en["button"] = {
    "proceed.to.pay": "Proceed to Pay",
    "pay": "Pay",
    "pay.post.text": "to Register Autopay",
    "add": "Add",
    "remove": "Remove"
};
_en["error"] = {
    "something.went.wrong": "Something went wrong. Please try again later",
    "partial.amount.max": "Amount entered cannot be greater than the payable amount"
};

_en["footer"] = {
    "visit.payment.link": "To create Payment Links, visit",
    "visit.payment.invoice": "To create Payment Invoices, visit"
};
_en["subscription"] = (_en$subscription = {
    "name": "Name",
    "email": "Email",
    "mobile": "Mobile",
    "subscription.at": "Your Subscription at",
    "subscription.for": "subscription for",
    "subscription.details": "subscription details",
    "your.subs": "Your Subscription at",
    "plan.desc": "Plan Name and Description",
    "plan.amount": "Plan Amount",
    "next.bill": "Next Billing Date:",
    "subs.start.date": "Subscription Start Date",
    "valid.till": "Subscription Valid Till",
    "mandate.start.date": "Mandate Start Date",
    "mandate.valid.till": "Mandate Valid Till",
    "first.payment": "FIRST PAYMENT",
    "next.payment": "NEXT PAYMENTS",
    "footer.text": "100% Secure Payments Powered by Paytm",
    "upto": 'upto',
    "pay.info": "IMPORTANT: Please ensure that you only pay to merchants you already know. Never make a payment to a non-trusted merchant for offers or prizes as it may be a scam",
    "next.on.demand": "Upto \u20B9$amount will be charged until the subscription is valid",
    "next.fixed.interval": "$frequency after the first payment upto \u20B9$amount will be charged until the subscription is valid",
    "first.amount": "Amount",
    "inclusive": "(inclusive of one time charge)"
}, _en$subscription["first.payment"] = "FIRST PAYMENT", _en$subscription["next.payment"] = "NEXT PAYMENT", _en$subscription["upto.min"] = "upto \u20B9$amount may be deducted from your bank", _en$subscription["is.active"] = "Your subscription is active.", _en$subscription["trial.period"] = "TRIAL PERIOD", _en$subscription["trial.text"] = "$time day trial period", _en$subscription["DAY"] = " Per Day", _en$subscription["MONTH"] = " Per Month", _en$subscription["YEAR"] = " Per Year", _en$subscription["WEEK"] = " Per Week", _en$subscription["QUARTER"] = " Every Quarter", _en$subscription["BI_MONTHLY"] = " Every 2 Months", _en$subscription["SEMI_ANNUALLY"] = " Every Half-year", _en$subscription["FORTNIGHT"] = " Every Fortnight", _en$subscription["show.more"] = "Show more", _en$subscription["merchant.name"] = "Merchant name", _en$subscription["confirm.cancel"] = "Confirm Cancellation", _en$subscription["cancel.warning"] = "If you cancel now, you can still access your subscription till", _en$subscription["cancel.msg"] = "You can still access your subscription till", _en$subscription["got.it"] = "Ok. got it", _en$subscription["proceed.cancel"] = "Proceed to Cancel", _en$subscription["cancelled"] = "Your Subscription has been cancelled", _en$subscription["not.now"] = "Not Now", _en$subscription["mobile.number"] = "Mobile Number", _en$subscription["update"] = "Update", _en$subscription["update.mobile"] = "Update Mobile No.", _en$subscription["verify.mobile"] = "Verify Mobile Number", _en$subscription["enter.otp.mobile"] = "Enter OTP sent to mobile no.", _en$subscription["confirm"] = "Confirm", _en$subscription["failed.to.send"] = "Failed to resend OTP. No attempts left!", _en$subscription["otp.resent"] = "OTP resent Successfully.", _en$subscription["left.attempt"] = "attempt left", _en$subscription["contact"] = "Contact Merchant", _en$subscription["pay.history"] = "Payment History", _en$subscription["cancel"] = "Cancel Subscription", _en$subscription["invalid.otp"] = "Please enter a valid OTP", _en$subscription["email.id"] = "Email ID", _en$subscription["update.email"] = "Update Email ID", _en$subscription["contact.merchant"] = "Contact Merchant", _en$subscription["enter.mobile.number"] = "Please enter your mobile number", _en$subscription["enter.valid.mobile"] = "Please enter a valid mobile number", _en$subscription["enter.email"] = "Please enter your email id", _en$subscription["enter.valid.email"] = "Please enter a valid email id", _en$subscription["processing"] = "Processing", _en$subscription["failed"] = "Failed", _en$subscription["paid"] = "Paid", _en$subscription["is.cancelled"] = "Your subscription is cancelled.", _en$subscription["cancel.date"] = "Cancelled date is", _en$subscription["is.expired"] = "Your subscription is expired.", _en$subscription["expiry.date"] = "Expired on", _en$subscription["is.closed"] = "Your subscription is closed.", _en$subscription["authorization.failed"] = "Your subscription is not authorized.", _en$subscription.authorized = "Your subscription is authorized.", _en$subscription.suspended = "Your subscription is paused.", _en$subscription["close.date"] = "Closed on", _en$subscription["susbs.cancel"] = "Are you sure you want to cancel the subscription?", _en$subscription);

_en["paymentDetails"] = {
    "amt.to.be.paid": "Amount to be paid",
    "total.amt": "Total link amount",
    "amt.paid.till.date": "Amount paid till date",
    "blocked.amt": "Payment under process",
    "payable.amt": "Balance payable",
    "link.valid.till": "This link is valid till",
    "merchant.ref": "Merchant reference ID"
};

/* harmony default export */ var en = (_en);
// CONCATENATED MODULE: ./index.form.js

// import './style/font';




i18n["a" /* i18nUtils */].load(en);

/* harmony default export */ var index_form = __webpack_exports__["default"] = (app_PaymentForm);

/***/ }),

/***/ "VHod":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"product-info":"_1HTb","input-list":"_1otA","payBtn":"_1i0a"};

/***/ }),

/***/ "bsih":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rupee-sign":"_1LM7","has-val":"_liLs","pos-r":"_2xVi","amt-label":"_3HsA","ibl":"_GMxn","tr":"_2U3I","clear":"_GxXr","ib":"_1aDp","custom-check":"_2tdS","c-mark":"_OB75","c-mark-box":"_2STw","amount-inp":"_IzDC","cb":"_3qvR","info":"_3yRx","fix-amt":"_3bI7"};

/***/ }),

/***/ "cxRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return intializeLogger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logEvent; });
var pushEvent = window && window.Logger || undefined;

var intializeLogger = function intializeLogger(pageName, pageData) {
  if (pushEvent) {
    var config = {};
    config.env =  true ? pageName + "_" + "prod_ppsl" : pageName + "_dev";
    if (config.env === pageName + "_prod" || config.env === pageName + "_preprod" || config.env === pageName + "_stage-aws") {
      config.debug = false;
    }
    config.meta = pageData;
    config.service = "link_payment_form_ui";
    if (typeof pushEvent.log === "function") {
      pushEvent.init(config);
    }
  }
};

var logEvent = function logEvent(obj) {
  if (pushEvent && typeof pushEvent.log === "function") {
    pushEvent.log(obj);
  }
};

/***/ }),

/***/ "d/uS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ptm-checkoutjs-lg-wrapper":"_2T9r","ptm-checkoutjs-container":"_2TUj","ptm-checkoutjs-footer":"_2Sad","ptm-checkoutjs-footer-container":"_2HOP","ptm-checkoutjs-f-i-container":"_27SO","ptm-checkoutjs-b-f-container":"_12og","b1-style":"_ibc-","b2-style":"_2Ic2"};

/***/ }),

/***/ "dkoj":
/***/ (function(module, exports) {

var _cache = {};

var _get = function _get(key) {
  return _cache[key];
};

var _set = function _set(key, value) {
  _cache[key] = value;
};

var _reset = function _reset() {
  _cache = {};
};

module.exports = {
  get: _get,
  set: _set,
  clear: _reset
};

/***/ }),

/***/ "gbHb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"submit-btn":"_3plG","hide-btn-text":"_2YAu","spinner":"_1mnL","bounce":"_31AK","bounce4":"_O9ha","bounce5":"_HYAO","bounce1":"_MI2_","bounce2":"_1j-H","bounce3":"_3lhA","rupee-sign":"_3E3t","btn-primary":"_1hX2"};

/***/ }),

/***/ "gfUn":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
  var keys = Object.keys(obj);
  var descriptors = {};
  for (var i = 0; i < keys.length; i++) {
    descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
  }
  return descriptors;
};

var formatRegExp = /%[sdj%]/g;
exports.format = function (f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function (x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s':
        return String(args[i++]);
      case '%d':
        return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};

// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function (fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function () {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};

var debugs = {};
var debugEnviron;
exports.debuglog = function (set) {
  if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function () {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function () {};
    }
  }
  return debugs[set];
};

/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;

// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold': [1, 22],
  'italic': [3, 23],
  'underline': [4, 24],
  'inverse': [7, 27],
  'white': [37, 39],
  'grey': [90, 39],
  'black': [30, 39],
  'blue': [34, 39],
  'cyan': [36, 39],
  'green': [32, 39],
  'magenta': [35, 39],
  'red': [31, 39],
  'yellow': [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};

function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\x1B[' + inspect.colors[style][0] + 'm' + str + '\x1B[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}

function stylizeNoColor(str, styleType) {
  return str;
}

function arrayToHash(array) {
  var hash = {};

  array.forEach(function (val, idx) {
    hash[val] = true;
  });

  return hash;
}

function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect && value && isFunction(value.inspect) &&
  // Filter out the util module, it's inspect function is special
  value.inspect !== exports.inspect &&
  // Also filter out any prototype objects using the circular check.
  !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '',
      array = false,
      braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function (key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}

function formatPrimitive(ctx, value) {
  if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value)) return ctx.stylize('' + value, 'number');
  if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value)) return ctx.stylize('null', 'null');
}

function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}

function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function (key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    }
  });
  return output;
}

function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function (line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function (line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}

function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function (prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
  typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__("vexR");

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}

var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}

// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function () {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__("4Bm0");

exports._extend = function (origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
};

exports.promisify.custom = kCustomPromisifiedSymbol;

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function cb() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args).then(function (ret) {
      process.nextTick(cb, null, ret);
    }, function (rej) {
      process.nextTick(callbackifyOnRejected, rej, cb);
    });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/***/ }),

/***/ "hafV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _constant$INPUTVALIDA;

var _constant = {};
var decodeURIwindow = function decodeURIwindow() {
  if (typeof window !== "undefined") {
    return window.decodeURIComponent("%E2%80%99");
  }
  return "";
};

_constant.USER_AGENT_MOBILE = "MOBILE";
_constant.USER_AGENT_WEB = "WEB";
_constant.INPUT_TEXT_REGEX = /<(.|\n)*?>/g;
_constant.MOBILE_REG_EX = /[6789]{1}[0-9]*/;
_constant.NUMBER_REG_EX = /[^0-9]/g;
_constant.ADD_DESC_REGEX = new RegExp("^([a-zA-Z0-9-'" + decodeURIwindow() + " \u2019& ]){3,30}$");
_constant.MID = "MID";
_constant.TOKEN = "TOKEN";
_constant.UNIQUEID = "UNIQUEID";
_constant.OTP_MAX_RESEND = 5;
_constant.H_ORIENTATION = "H";
_constant.V_ORIENTATION = "V";
_constant.DATE_ORDINAL = "/";
_constant.PAYTM_BUSINESS_LINK_URL = "https://business.paytm.com/payment-link";
_constant.PAYTM_BUSINESS_INVOICE_URL = "https://business.paytm.com/payment-invoices";
_constant.MOBILE_NUMBER = "MOBILENUMBER";
_constant.EMAIL_ID = "EMAILID";
_constant.DOB = "DOB";
_constant.DELIVERY_ADDRESS = "DELIVERYADDRESS";
_constant.GENDER = "GENDER";
_constant.FULL_NAME = "FULLNAME";
_constant.REGISTERED_ADDRESS = "REGISTEREDADDRESS";
_constant.AGE = "AGE";
_constant.AMOUNT = "Amount";
_constant.CUSTOM = "CUSTOM";
_constant.CUSTOM_TEXT = "Text";
_constant.CUSTOM_NUMBER = "Numeric";
_constant.CUSTOM_DROPDOWN = "Dropdown";
_constant.CUSTOM_DATE = "Date";
_constant.CUSTOM_AMOUNT = "UserAmount";
_constant.CUSTOM_MOBILE_NUMBER = "MobileNumber";
_constant.CUSTOM_AMOUNT = "UserAmount";
_constant.CUSTOM_AMOUNT_MERCHANT = "Amount";
_constant.CUSTOM_AMOUNT_FLEXIBLE = "FlexibleAmount";
_constant.CUSTOM_AMOUNT_QUANTATIVE = "QuantityAmount";
_constant.CUSTOM_AMOUNT_PARTIAL = "PartialAmount";
_constant.CUSTOM_AMOUNT_HIDDEN = "HiddenAmount";
_constant.CUSTOM_AMOUNT_DROPDOWN = "DropdownAmount";
_constant.midlink = "mid";
_constant.merchantName = "merchantName";
_constant.VALIDATION_FIXED = "Fixed Text";
_constant.VALIDATION_SHORT = "Short Text";
_constant.VALIDATION_LONG = "Long Text";
_constant.SHORT_VALLIDATION_MIN_CHAR = 3;
_constant.SHORT_VALLIDATION_MAX_CHAR = 30;
_constant.LONG_VALLIDATION_MIN_CHAR = 3;
_constant.LONG_VALLIDATION_MIN_CHAR = 200;
_constant.LENGTH_VALIDATION_CHAR = "lengthValidationChar";
_constant.FIXED_VALIDATION_CHAR = "fixedValidationChar";
_constant.LENGTH_VALIDATION_NUMBER = "lengthValidationNumber";
_constant.FIXED_VALIDATION_NUMBER = "fixedValidationNumber";
_constant.MANDATORY_VALIDATION = "isMandatoryValidation";
_constant.DATE_VALIDATION = "dateValidation";
_constant.LIST_VALIDATION = "listValidation";
_constant.NUMBER_VALIDATION = "numberValidation";
_constant.TEXT_VALIDATION = "textValidation";
_constant.PIN_VALIDATION = "PINValidation";
_constant.MOBILE_NUMBER_VALIDATION = "mobileNumberValidation";
_constant.EMAIL_VALIDATION = "emailValidation";
_constant.ACTIVE = "ACTIVE";
_constant.INACTIVE = "INIT";
_constant.REJECT = "REJECT";
_constant.EXPIRED = "EXPIRED";
_constant.CLOSED = "CLOSED";
_constant.AUTHORIZATION_FAILED = "AUTHORIZATION_FAILED";
_constant.AUTHORIZED = "AUTHORIZED";
_constant.SUSPENDED = "SUSPENDED";
_constant.SUBS_MIN_AMOUNT = 1;
_constant.ONDEMAND = "ONDEMAND";
_constant.BUTTON_CLICKED = "BUTTON_CLICKED";
_constant.API_FAIL = "API_FAIL";
_constant.API_SUCCESS = "API_SUCCESS";
_constant.LINK_ID = "LINKID";
_constant.YMD_FORMAT = "YYYY/MM/DD";
_constant.DMY_FORMAT = "MM/DD/YYYY";
_constant.POPUP_CLOSED = "POPUP_CLOSED";
_constant.POPUP_OPENED = "POPUP_OPENED";
_constant.POPUP_IN = "POPUP_IN";
_constant.AMOUNT_FIXED = "FIX";
_constant.AMOUNT_VARIABLE = "VARIABLE";
_constant.EMAIL_REG_EX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
_constant.CANCEL = "CANCEL";
_constant.SUBS_ID = "SUBSCRIPTION_ID";
_constant.CANCEL_SUBSCRIPTION_STATE = "CANCEL_SUBSCRIPTION_STATE";
_constant.RESEND_OTP = "RESEND_OTP";
_constant.FAILED = "FAILED";
_constant.PENDING = "PENDING";
_constant.LINK_NAME = "LINK_NAME";
_constant.LINK_ID_PREFIX = "LL_";
_constant.IS_AOA_FLOW = "IS_AOA_FLOW";

/* ---------------- API URLs -----------------------*/

_constant.LINK = "link";
_constant.BUILD = "build";
_constant.BASE_URL = "";
_constant.PAYMENT_FORM_SUBMIT_URL = "link/form/submitUserForm";
_constant.MOBILE_NUMBER_SUBMIT_URL = "theia/linkPayment/generateSendOTP";
_constant.OTP_SUBMIT_URL = "theia/linkPayment/validateSendOTP";
_constant.EDIT_SUBSCRIPTION = "subscription/v3/panel/edit";
_constant.EDIT_SUBSCRIPTION_AUTH = "subscription/v3/panel/edit/authorize";
_constant.PAYMENTPAGEVALIDATEUSER = "link/form/validateUserDetails";

_constant.INPUTVALIDATOR = (_constant$INPUTVALIDA = {}, _constant$INPUTVALIDA[_constant.LENGTH_VALIDATION_CHAR] = function (minLength, maxLength, val) {
  minLength = minLength || 3;
  maxLength = maxLength || 200;

  var _val$trim = val.trim(),
      length = _val$trim.length;

  if (length > maxLength) {
    return "maxError";
  }
  if (length < minLength) {
    return "minError";
  }
  return true;
}, _constant$INPUTVALIDA[_constant.LENGTH_VALIDATION_NUMBER] = function (minNumber, maxNumber, val) {
  minNumber = parseInt(maxNumber);
  maxNumber = parseInt(maxNumber);
  val = parseInt(val.trim());
  if (val > maxNumber) {
    return "maxError";
  }
  if (val < minNumber) {
    return "minError";
  }
  return true;
}, _constant$INPUTVALIDA[_constant.MANDATORY_VALIDATION] = function (val) {
  val = val.trim();
  if (val !== undefined && val !== null && val !== "") {
    return false;
  }
  return true;
}, _constant$INPUTVALIDA[_constant.FIXED_VALIDATION_CHAR] = function (fixedLength, val) {
  var _val$trim2 = val.trim(),
      length = _val$trim2.length;

  if (length !== fixedLength) {
    return "fixed";
  }
  return false;
}, _constant$INPUTVALIDA[_constant.FIXED_VALIDATION_NUMBER] = function (fixedValue, val) {
  val = parseInt(val.trim());
  if (val !== fixedValue) {
    return true;
  }
  return false;
}, _constant$INPUTVALIDA);

/* harmony default export */ __webpack_exports__["a"] = (_constant);

/***/ }),

/***/ "i7CM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fr":"_2tSf","business-link":"_3IwO","footer-txt":"_2mwO","ptm-logo":"_1vA3","txt-center":"_3pzL","m-hide-im":"_2rmj"};

/***/ }),

/***/ "jUR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rupee-sign":"_3Rkz","has-val":"_2p0b","pos-r":"_3n1G","amt-label":"_2Yi6","quantity":"_1-J7","ibl":"_2bNr","tr":"_3Y9B","clear":"_1UiP","link-btn":"_2sRQ","mult":"_2XI8","info":"_2WO3"};

/***/ }),

/***/ "kSUl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rupee-sign":"_240z","has-val":"_3X4X","pos-r":"_2cYA"};

/***/ }),

/***/ "kkOB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"remove-link":"_11sD","select-head":"_10Sk","disabled":"_azO6","drop-link":"_33HX","select-dropdown":"_TSVw","visible":"_KXNG","select-list":"_3PuK","select-item":"_3I23","remove":"_2mJB","select-para":"_2flD","floating-label":"_3wkU","value-added":"_38Vd","hidden":"_10UQ","list-option":"_35_T","select-input":"_313H"};

/***/ }),

/***/ "lcwS":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ "ocZ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateAmountMobile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validateAmountWeb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showRupee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return preventDefault; });
/* unused harmony export checkMerchantPreference */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_dev__ = __webpack_require__("uAm5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_dev___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_dev__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utility__ = __webpack_require__("NCO4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_cache__ = __webpack_require__("dkoj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_cache__);





// Mock APP_DATA to start application
// if (typeof window !== "undefined" && ENV === "dev") {
//   require("../../mock-app-data");
// }

var _parsePaymentFormData = function _parsePaymentFormData(input) {
  if (input) {
    input.partialAmountData = {
      isPartialPayment: Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(input, "isPartialPayment", false),
      paidAmount: isAmountZero(Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(input, "paidAmount", "")),
      blockAmount: isAmountZero(Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(input, "blockAmount", "")),
      payableAmount: isAmountZero(Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(input, "payableAmount", "")),
      totalAmount: isAmountZero(Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(input, "amount", "")),
      partialLinkPayments: Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(input, "partialLinkPayments", [])
    };
  }
  if (input && input.fields) {
    var fields = input.fields;
    // fields other than amount

    var parsedFields = fields.filter(function (item) {
      return !item.type || item.type !== __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_MERCHANT && item.type !== __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_FLEXIBLE && item.type !== __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_QUANTATIVE;
    });
    // fields wiht amount
    parsedFields = parsedFields.concat(fields.filter(function (item) {
      return item.type && item.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_MERCHANT || item.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_FLEXIBLE || item.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_QUANTATIVE;
    }));
    input.fields = flattenFields(parsedFields, input);
  }
  return input;
};

var parseHeaderData = function parseHeaderData(input) {
  var data = {};
  var isZeroAmount = Number(input.upfrontTxnAmount) === 0;
  data.upFrontAmount = input.upfrontTxnAmount;
  data.isZeroAmount = isZeroAmount;
  data.payableAmount = isZeroAmount ? __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].SUBS_MIN_AMOUNT : input.upfrontTxnAmount;
  data.nextBilling = input.nextRenewalDate;
  data.merchantName = input.merchantName;
  data.mid = input.mid;
  data.logoURL = input.merchantLogoUrl;
  data.linkId = input.linkId;
  data.expiredDate = input.subscriptionEndDate;
  data.cancelledDate = input.subscriptioncancelledDate;
  data.closedDate = input.subscriptionClosedDate;
  data.linkName = input.linkName;
  return data;
};

var parseSubscriptionData = function parseSubscriptionData(input) {
  var data = {};
  data.name = input.customerName;
  data.mobile = input.customerPhoneNo;
  data.email = input.customerEmail;
  data.planName = input.planName;
  data.planDescription = input.linkDescription;
  data.frequency = input.frequencyUnit;
  data.nextBilling = input.nextRenewalDate;
  data.subsStartDate = input.subscriptionStartDate;
  data.endDate = input.subscriptionEndDate;
  data.upFrontAmount = input.upfrontTxnAmount;
  data.planAmount = input.amountType === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].AMOUNT_FIXED ? input.renewalAmount : input.maxAmount;
  data.renewalAmount = input.amountType === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].AMOUNT_VARIABLE ? input.maxAmount : input.renewalAmount;
  data.merchantPreferenceInfos = input.merchantPreferenceInfos;
  data.amountType = input.amountType;
  data.subscriptionStatus = input.subscriptionStatus;
  data.paymentHistory = parsePaymentData(input.paymentDetails);
  data.trialPeriod = input.trialPeriod; // Number(input.trialPeriod);
  data.merchantDetails = { name: input.merchantName, mobile: input.merchantPhoneNo, email: input.merchantEmail };
  data.subsId = input.subscriptionId;
  return data;
};

var parseSubscriptionAppData = function parseSubscriptionAppData(input) {
  var appData = JSON.parse(JSON.stringify(input));
  delete appData.customerPhoneNo;
  delete appData.customerEmail;
  delete appData.customerName;
  var paymentDetails = Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(appData, "paymentDetails", []);
  for (var i = 0; i < paymentDetails.length; i++) {
    delete paymentDetails[i].customerMobileNo;
    delete paymentDetails[i].customerEmailId;
    delete paymentDetails[i].cardNo;
  }
  return appData;
};

var parseFormAppData = function parseFormAppData(input) {
  var appData = JSON.parse(JSON.stringify(input));

  delete appData.customerPhoneNo;
  delete appData.customerEmail;
  delete appData.customerName;
  delete appData.fields;

  return appData;
};

var parsePaymentPagesData = function parsePaymentPagesData(input) {
  var appData = JSON.parse(JSON.stringify(input));
  appData.mid = input.mid;
  appData.linkId = input.linkId;
  return appData;
};

var parseInvoiceAppData = function parseInvoiceAppData(input) {
  var appData = JSON.parse(JSON.stringify(input));

  delete appData.customerPhoneNo;
  delete appData.customerEmail;
  delete appData.customerName;
  delete appData.invoiceEmail;
  delete appData.invoicePhoneNo;

  return appData;
};

var parsePaymentPageInvoiceAppData = function parsePaymentPageInvoiceAppData(input) {
  var appData = JSON.parse(JSON.stringify(input));

  delete appData.userEmailId;
  delete appData.userMobileNo;
  delete appData.userName;
  delete appData.userDefinedFields;
  delete appData.userId;

  if (appData.paymentPage) {
    delete appData.paymentPage.merchantEmail;
    delete appData.paymentPage.merchantMobile;
    delete appData.paymentPage.merchantAddress;
  }

  // if (appData.paymentFormData) {
  //   delete appData.paymentFormData.merchantEmail;
  //   delete appData.paymentFormData.merchantMobile;
  //   delete appData.paymentFormData.merchantAddress;
  // }

  return appData;
};

var parseLinkAppData = function parseLinkAppData(input) {
  var appData = JSON.parse(JSON.stringify(input));

  delete appData.bindMobile;

  return appData;
};

var parsePaymentData = function parsePaymentData(data) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(data, "length", 0)) {
    return data.map(function (item) {
      return { amount: item.txnAmount, status: item.status, date: item.timeStamp };
    });
  }
  return [];
};

var flattenFields = function flattenFields(fields, input) {
  var parentField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

  var flatenArray = [];
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    if (field.hasOwnProperty("helpText") && field.helpText) {
      field.subText = field.helpText;
    }
    // check for Amount field
    if (field.hasOwnProperty("name") && field.name && field.name === "txnAmount") {
      field.type = __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT;
    }
    if (field.hasOwnProperty("type") && field.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_MERCHANT && Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(input, "partialAmountData.isPartialPayment", false)) {
      field.type = __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_PARTIAL;
    }
    if (parentField) {
      field.parentField = parentField;
    }
    if (field.fields) {
      var parentFieldName = field.name ? field.name : "";
      flatenArray = flatenArray.concat(flattenFields(field.fields, input, parentFieldName));
      if (field.subText) {
        flatenArray[flatenArray.length - 1].parentSubText = field.subText;
      }
    } else {
      flatenArray.push(parseField(field, input));
    }
  }
  return flatenArray;
};

var parseField = function parseField(field, input) {
  field.placeholder = field.displayText ? field.displayText : field.name;
  field.placeholder = field.mandatory ? field.placeholder + "*" : field.placeholder;
  field.isError = false;
  field.errorName = "";
  field.inputValue = "";
  field.subText = field.subText || "";
  if (field.type) {
    customField(field, input);
  }
  return field;
};

var customField = function customField(field, input) {
  switch (field.type) {
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_TEXT:
      textField(field);
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_NUMBER:
      numberField(field);
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_DROPDOWN:
      dropDownField(field);
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_DROPDOWN:
      dropDownAmountField(field);
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_DATE:
      dateField(field);
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT:
      textField(field);
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_MERCHANT:
      numberField(field);
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_PARTIAL:
      partialAmountField(field, input);
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_QUANTATIVE:
      quantityAmountField(field);
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_MOBILE_NUMBER:
      textField(field);
      break;
  }
};

var _setPostPaymentFormData = function _setPostPaymentFormData(fields) {
  var parsedFields = [];
  fields.forEach(function (element) {
    var item = {};
    item.name = element.name ? element.name : "";
    item.value = element.inputValue ? element.inputValue : "";
    if (element.parentField) {
      var index = checkElementDoesExist(parsedFields, element.parentField);
      if (index > -1) {
        parsedFields[index].fields.push(item);
      } else {
        parsedFields.push({ name: element.parentField, fields: [item] });
      }
    } else {
      parsedFields.push(item);
    }
  });
  return parsedFields;
};
var checkElementDoesExist = function checkElementDoesExist(parsedFields, parentField) {
  return parsedFields.findIndex(function (_ref) {
    var name = _ref.name;
    return name == parentField;
  });
};
var dateField = function dateField(field) {
  if (field.constraints && field.constraints.afterTransaction) {
    field.constraints.minValue = Object(__WEBPACK_IMPORTED_MODULE_2__utility__["a" /* formatDate */])("DD" + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATE_ORDINAL + "MM" + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATE_ORDINAL + "YYYY", new Date());
  }
  if (field.constraints && field.constraints.beforeTransaction) {
    field.constraints.maxValue = Object(__WEBPACK_IMPORTED_MODULE_2__utility__["a" /* formatDate */])("DD" + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATE_ORDINAL + "MM" + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATE_ORDINAL + "YYYY", new Date());
  }
  validationValues(field, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DATE_VALIDATION, field.mandatory ? field.mandatory : false);
};
var dropDownField = function dropDownField(field) {
  validationValues(field, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].LIST_VALIDATION, field.mandatory ? field.mandatory : false);
  var allowedValues = Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(field, "constraints.allowedValues", null);
  if (allowedValues) {
    field.constraints.allowedValues = [field.name].concat(allowedValues);
  }
};
var dropDownAmountField = function dropDownAmountField(field) {
  validationValues(field, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].LIST_VALIDATION, field.mandatory ? field.mandatory : false);
  var allowedValues = Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(field, "constraints.allowedValues", null);
  if (allowedValues) {
    field.constraints.allowedValues = [{ name: field.name, value: "" }].concat(allowedValues);
  }
};
var textField = function textField(field) {
  validationValues(field, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].TEXT_VALIDATION, field.mandatory ? field.mandatory : false);
};

var numberField = function numberField(field) {
  validationValues(field, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].NUMBER_VALIDATION, field.mandatory ? field.mandatory : false);
};
var quantityAmountField = function quantityAmountField(field) {
  if (field.constraints) {
    field.constraints.minValue = field.constraints.minQuantity ? field.constraints.minQuantity : "";
    field.constraints.maxValue = field.constraints.maxQuantity ? field.constraints.maxQuantity : "";
  }
  validationValues(field, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].NUMBER_VALIDATION, field.mandatory ? field.mandatory : false);
};
var validationValues = function validationValues(field, type, mandatory) {
  field.constraints[__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].MANDATORY_VALIDATION] = mandatory;
  field.constraints.validationType = type;
};
var partialAmountField = function partialAmountField(field, input) {
  var maxValue = Object(__WEBPACK_IMPORTED_MODULE_2__utility__["c" /* getKey */])(input, "partialAmountData.payableAmount", "");
  if (field.constraints && maxValue) {
    field.constraints.maxValue = maxValue;
  }
  validationValues(field, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].NUMBER_VALIDATION, field.mandatory ? field.mandatory : false);
};
var validateAmountMobile = function validateAmountMobile(event) {
  if (event && event.target) {
    var amt = event.target.value;
    if (amt === "." || amt === "0") {
      event.target.value = "";
      return false;
    }
  } else {
    return false;
  }
};

var validateAmountWeb = function validateAmountWeb(event) {
  if (!event) return false;
  if (Object(__WEBPACK_IMPORTED_MODULE_2__utility__["d" /* isNumber */])(event) || event.keyCode === 190) {
    if (!event.target.value && (String.fromCharCode(event.which) == "0" || event.keyCode === 190)) {
      return false;
    }
    if (event.keyCode === 9) return true;

    return true;
  }
  return false;
};

var showRupee = function showRupee(event, isDesktop) {
  if (isDesktop) {
    if (event.keyCode === 8) {
      if (event && event.target.value.length > 1) {
        return true;
      }
      return false;
    }
    if (event && (event.target.value + event.key).length > 0) {
      return true;
    }
    return false;
  }
  if (event && event.target && event.target.value && event.target.value.length > 0) {
    return true;
  }
  return false;
};

var preventDefault = function preventDefault(event) {
  event.preventDefault();
  event.stopPropagation();
  return false;
};
var _isNullOrUndefined = function _isNullOrUndefined(val) {
  return val === undefined || val === null;
};

var _redirectToURL = function _redirectToURL(url) {
  if (url) {
    if (typeof window !== "undefined") {
      window.location.href = url;
    }
  }
};

var _getStaticPath = function _getStaticPath() {
  var _url = "https://staticpg.paytmpayments.com";

  try {
    if (typeof window !== "undefined") {
      if (true) {
        _url += "/" + "link" + "/" + "418" + "/" + "form";
      }
    }
  } catch (e) {}
  return _url;
};

var _getAPIHOST = function _getAPIHOST() {
  if (true) {
    return __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_URL + "https://secure.paytmpayments.com";
  }
  return "";
};

var _getAPIHOSTForAOA = function _getAPIHOSTForAOA() {
  if (true) {
    return "https://router.paytm.in";
  }
  return "";
};

var _getAmountFieldFirtsIndex = function _getAmountFieldFirtsIndex(options) {
  var item = void 0;
  var firstIndex = -1;
  for (var index = 0; index < options.length; index++) {
    item = options[index];
    if (item.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_QUANTATIVE || item.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_MERCHANT || item.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_FLEXIBLE || item.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_PARTIAL || item.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].CUSTOM_AMOUNT_DROPDOWN) {
      firstIndex = index;
      break;
    }
  }
  return firstIndex;
};

var addClassOnBody = function addClassOnBody(newClass) {
  if (document.body.className.indexOf(newClass) == -1) document.body.className = document.body.className + " " + newClass;
};
var removeClassFromBody = function removeClassFromBody(newClass) {
  if (document.body.className.indexOf(newClass) > -1) document.body.className = document.body.className.replace(" " + newClass, "");
};

var isAmountZero = function isAmountZero(amt) {
  amt = Object(__WEBPACK_IMPORTED_MODULE_2__utility__["f" /* numberWithoutCommas */])(amt);
  if (!Number(amt) || isNaN(amt)) {
    return "";
  }
  return Number(amt).toString();
};

var isWebView = function isWebView() {
  var userAgent = window.navigator && window.navigator.userAgent;
  /* Check for Safari Web View */
  var isSafariWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent);
  if (isSafariWebView || /wv/i.test(userAgent) || !/UCBrowser/g.test(userAgent) && /version\/[0-9].[0-9]/i.test(userAgent) && /Chrome\/\d*.\d*.\d*.\d*/i.test(userAgent)) {
    return true;
  }
  return false;
};

var invokeCheckoutJS = function invokeCheckoutJS(config) {
  console.log("invokeCheckoutJS");
  return new Promise(function (resolve, reject) {
    if (window.Paytm && window.Paytm.CheckoutJS) {
      window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
        // after successfully updating configuration, invoke JS Checkout
        window.Paytm.CheckoutJS.invoke();
        resolve(true);
      }).catch(function onError(error) {
        console.log("error => ", error);
        reject(error);
      });
    }
  });
};

var setupCheckoutJS = function setupCheckoutJS(host, mid) {
  var hostCheckoutJS = host + "/merchantpgpui/checkoutjs";
  var isAOAFlow = Object(__WEBPACK_IMPORTED_MODULE_3__utils_cache__["get"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].IS_AOA_FLOW);
  if (isAOAFlow) {
    hostCheckoutJS = _getAPIHOSTForAOA() + "/merchantpgpui/checkoutjs/aoa";
  }
  var src = hostCheckoutJS + "/merchants/" + mid + ".js";
  var script = document.createElement("script");
  script.crossOrigin = "anonymous";
  script.src = src;
  script.type = "application/javascript";
  document.body.appendChild(script);
  return script;
};

function checkMerchantPreference(prefType, data, defaultVal) {
  var preference = data && data.find(function (info) {
    return info.prefType === prefType;
  });
  if (preference && preference.prefValue) {
    return preference.prefValue === "Y";
  }
  return defaultVal;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  parsePaymentFormData: _parsePaymentFormData,
  isNullOrUndefined: _isNullOrUndefined,
  redirectToURL: _redirectToURL,
  getStaticPath: _getStaticPath,
  setPostPaymentFormData: _setPostPaymentFormData,
  getAPIHOST: _getAPIHOST,
  getAPIHOSTForAOA: _getAPIHOSTForAOA,
  getAmountFieldFirtsIndex: _getAmountFieldFirtsIndex,
  addClassOnBody: addClassOnBody,
  removeClassFromBody: removeClassFromBody,
  parseSubscriptionData: parseSubscriptionData,
  parseHeaderData: parseHeaderData,
  parsePaymentPagesData: parsePaymentPagesData,
  parseSubscriptionAppData: parseSubscriptionAppData,
  isWebView: isWebView,
  invokeCheckoutJS: invokeCheckoutJS,
  setupCheckoutJS: setupCheckoutJS,
  parseFormAppData: parseFormAppData,
  parseInvoiceAppData: parseInvoiceAppData,
  parseLinkAppData: parseLinkAppData,
  parsePaymentPageInvoiceAppData: parsePaymentPageInvoiceAppData
});

/***/ }),

/***/ "pcJx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"remove-link":"_1qNU","select-head":"_UdRj","disabled":"_Gw1M","drop-link":"_24LC","select-dropdown":"_25AG","visible":"_BY8R","select-list":"_2FJ4","select-item":"_3i45","remove":"_1lGI","select-para":"_3fL5","floating-label":"_1K4v","value-added":"_2hQE","hidden":"_1zgP","list-option":"_3f_i","select-input":"_24Mz"};

/***/ }),

/***/ "uAm5":
/***/ (function(module, exports) {

var _config = {};

_config['API_HOST'] = 'http://localhost:3000';
_config['STATIC_ASSET_HOST'] = 'http://localhost:8080';

module.exports = _config;

/***/ }),

/***/ "vexR":
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

/***/ }),

/***/ "yRZD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"_3ESJ","head-img-area":"_3O3l","headertxt1":"_3Oem","headertxt2":"_3rEM","headertxt3":"_29-E","merc-name":"_19sZ","mlogo":"_10tp","wlogo":"_3Siz","fee-for":"_2yKE","m-hidelogo":"_3jHf","fee-for-pos":"_Zv4c","w-hidelogo":"_2Gj5","down-arr":"_3jZ7","m-hide":"_396X"};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.94b80.js